<template>
  <div>
    <Header />
    <div id="divTest" class="latis">
      <div class="container">
        <!-- ****************** new design **************** -->
        <div class="back_btn">
          <router-link to="/">
            <i class="fa fa-arrow-left btn_checkout_back" aria-hidden="true"></i>
          </router-link>
        </div>
        <div class="panel-group" id="accordion">
          <div class="panel panel-default">
            <div class="panel-heading-h2">
              <h4 class="panel-title">
                <a style="color: #fff" type="button" @click="addclass(1)" class="btn">Review Cart ({{ cartItemCount }})
                </a>
              </h4>
            </div>
            <div id="collapse1" class="panel-collapse" :class="classofaccord1">
              <div class="panel-body">
                <div class="panel-collapse-collapse-in">
                  <div class="panel-body">
                    <div class="panel-collapse-collapse-in">
                      <div class="panel-body">
                        <div class="order-items-container" v-for="(item, index) in cartItems" :key="index">
                          <div class="order-items-container-child">
                            <div class="order-item-details-wrapper">
                              <img :src="item.item.items.image" class="order-item-image" alt=""
                                v-if="item.item.items.image" />
                              <!-- <img v-else class="order-item-image" src="https://images.dominos.co.in/new_margherita_2502.jpg">-->
                              <img v-else class="order-item-image" :src="defaultimg" />

                              <div class="order-item-title-container">
                                <div class="title" style="font-weight: bold"
                                  v-if="item.item.items.addon_optgrp_price == 0">
                                  {{ item.item.items.title }}

                                  <span v-if="item.add_charge.length > 0">
                                    (
                                    <span v-for="(charge, index) in item.add_charge" :key="index">
                                      {{ charge.add_charge_title }} ({{
                                          charge.add_charge_fixed_per === 0
                                            ? currency_symbol + ". "
                                            : ""
                                      }}{{ charge.add_charge_amt }})
                                      <span class="rupee">
                                        {{ currency_symbol + ". "
                                        }}{{ charge.calculated_charge_amt }}
                                      </span>
                                      <span v-if="
                                        index != item.add_charge.length - 1
                                      ">,
                                      </span>
                                    </span>
                                    )
                                  </span>

                                  <span v-if="item.item.items.discounted_price > 0">
                                    - (Discount:
                                    <span v-if="item.item.items.discount_type == 2" class="rupee"></span>
                                    <span>{{
                                        item.item.items.discount_rate
                                    }}</span><span v-if="item.item.items.discount_type == 1">%</span>
                                    )
                                  </span>
                                </div>

                                <div class="title" style="font-weight: bold" v-else>
                                  {{ item.item.items.add_opt_title }}
                                  <span v-if="item.add_charge.length > 0">
                                    (
                                    <span v-for="(charge, index) in item.add_charge" :key="index">
                                      {{ charge.add_charge_title }} ({{
                                          charge.add_charge_fixed_per === 0
                                            ? currency_symbol + ". "
                                            : ""
                                      }}{{ charge.add_charge_amt }})
                                      <span class="rupee">
                                        {{ currency_symbol + ". "
                                        }}{{ charge.calculated_charge_amt }}
                                      </span>
                                      <span v-if="
                                        index != item.add_charge.length - 1
                                      ">,
                                      </span>
                                    </span>
                                    )
                                  </span>

                                  <span v-if="item.item.items.discounted_price > 0">
                                    - (Discount:
                                    <span v-if="item.item.items.discount_type == 2" class="rupee"></span>
                                    <span>{{
                                        item.item.items.discount_rate
                                    }}</span><span v-if="item.item.items.discount_type == 1">%</span>
                                    )
                                  </span>
                                </div>

                                <div class="d-flex order-item-price">
                                  <div class="order-item-price" v-if="
                                    item.item.items.addon_optgrp_price == 0
                                  ">
                                    <span v-if="
                                      item.item.items.discounted_price == 0
                                    ">
                                      {{ currency_symbol }}.
                                      {{
                                          item.item.items.sale_price *
                                          item.quantity
                                      }}
                                    </span>

                                    <span v-if="
                                      item.item.items.discounted_price > 0
                                    ">
                                      {{ currency_symbol }}.
                                      {{
                                          item.item.items.discounted_price *
                                          item.quantity
                                      }}
                                    </span>
                                  </div>

                                  <div v-else class="order-item-price">
                                    <span v-if="
                                      item.item.items.discounted_price == 0
                                    ">
                                      {{ currency_symbol }}.
                                      {{
                                          item.item.items.addon_optgrp_price *
                                          item.quantity
                                      }}
                                    </span>

                                    <span v-if="
                                      item.item.items.discounted_price > 0
                                    ">
                                      {{ currency_symbol }}.
                                      {{
                                          (item.item.items.addon_optgrp_price /
                                            item.quantity) *
                                          item.quantity
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="product-item-sub-container">
                              <div class="
                                  product-item-button-wrapper
                                  update-item-wrapper
                                ">
                                <div class="update-item-button decrement" @click="
                                  deleteFromCart(
                                    item.item.items.item_id,
                                    item.item.items.title,
                                    item.item.items
                                  )
                                ">
                                  -
                                </div>
                                <div class="
                                    update-item-button
                                    button-secondary-cta
                                    qty-container
                                  ">
                                  {{ item.quantity }}
                                </div>
                                <div class="update-item-button increment" @click="addToCart(item.item.items)">
                                  +
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr />
                      <div class="col-sm-8">
                        <div class="form-group">
                          <b-form-textarea class="form-control" id="textarea" v-model="usernote"
                            placeholder="Enter any special instruction for kitchen. Eg: More Spicy" rows="3">
                          </b-form-textarea>
                        </div>
                        <div>
                          <div class="col-md-6" style="
                              width: 50%;
                              text-align: left;
                              padding-right: 5px;
                              padding-left: 5px;
                            ">
                            <p style="font-size: 15px">Order Type</p>
                          </div>
                          <div class="col-md-6" style="
                              width: 50%;
                              text-align: right;
                              padding-right: 5px;
                              padding-left: 5px;
                            ">
                            <p style="
                                text-transform: capitalize;
                                font-size: 15px;
                              ">
                              {{ deliverytype }}
                              <b-icon-pencil-fill @click="changeOrderType()" style="margin-left: 5px; font-size: 16px">
                              </b-icon-pencil-fill>
                            </p>
                          </div>
                        </div>
                        <div v-if="deliverytype == 'delivery'">
                          <div v-if="
                            userinfolocal.address === undefined ||
                            userinfolocal.address.length == 0
                          ">
                            <div v-if="
                              userinfolocal.address === undefined ||
                              userinfolocal.address.length === 0
                            " class="col-md-12 add-address-container" style="
                                width: 100%;
                                text-align: center;
                                padding-right: 5px;
                                padding-left: 5px;
                              ">
                              <button @click="manualAddress" title="Add a new delivery address"
                                class="add_address_button">
                                <i class="addaddress spx-1 mr-2 fa fa-plus" style="color: #ffbb0e; font-size: 14px"></i>
                                <div>Add a New Address</div>
                              </button>
                            </div>
                          </div>

                          <div v-if="
                            userinfolocal.address != undefined &&
                            userinfolocal.address.length > 0
                          " class="col-md-12 add-address-container" style="
                              width: 100%;
                              text-align: center;
                              padding-right: 5px;
                              padding-left: 5px;
                            ">
                            <div class="cart-customer-address order_instruction" style="margin-bottom: 10px">
                              <div class="pl-2 mr-2" style="font-size: 15px">
                                Address :
                              </div>
                              <div class="addresscontainer">
                                <div>
                                  <div v-for="user in userinfolocal.address" style="
                                      font-size: 15px;
                                      font-weight: bold;
                                      text-align: justify;
                                    " class="full-address" :key="user.id">
                                    <span v-if="user.is_default == 1">{{ user.google_address }},
                                      {{ user.manual_address }},
                                      {{ user.floor }},
                                      {{ user.landmark }}</span>

                                    <i class="fa fa-pencil" v-if="user.is_default == 1" @click="showAllAddress" style="
                                        margin-left: 5px;
                                        font-size: 16px;
                                        background-color: #374b43;
                                        color: #fff !important;
                                        padding: 5px;
                                      "></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <br />
                        <br />

                        <div style="margin-top: auto; margin-bottom: auto"
                          v-if="digital_order_setting.order_later == 1">
                          <h5 style="padding-bottom: 10px">
                            When do you want your order?
                          </h5>
                          <div class="row">
                            <div style="
                                display: flex;
                                justify-content: space-between;
                              ">
                              <div class="col-md-6" style="width: 100%">
                                <b-button v-if="order_now === false" class="order_now" variant="primary"
                                  @click="orderTimeOption('now')">Order Now</b-button>

                                <b-button v-if="order_now === true" class="order_now_active" variant="primary"
                                  @click="orderTimeOption('now')">Order Now</b-button>
                              </div>
                              <div class="col-md-6" style="width: 100%">
                                <b-button v-if="order_later === false" class="order_later" variant="primary"
                                  @click="orderTimeOption('later')">Order Later</b-button>

                                <b-button v-if="order_later === true" class="order_later_active" variant="primary"
                                  @click="orderTimeOption('later')">Order Later</b-button>
                              </div>
                            </div>
                            <div style="
                                display: flex;
                                justify-content: space-between;
                              ">
                              <div v-if="order_later == true" class="col-md-6" style="width: 100%">
                                <datetime type="date" :format="{
                                  year: 'numeric',
                                  month: 'numeric',
                                  day: 'numeric',
                                }" :phrases="{ ok: 'Ok', cancel: 'Exit' }" placeholder="Select Date"
                                  v-model="datetimeEmpty" :min-datetime="minDatetime" :max-datetime="maxDatetime">
                                </datetime>
                              </div>
                              <div class="col-md-6" v-if="order_later === true" style="width: 100%">
                                <b-dropdown :text="selected_order_time_slots" block variant="info" style="
                                    color: #000;
                                    margin: 10px 0px;
                                    float: unset;
                                  ">
                                  <b-dropdown-item v-for="(
                                      item, key
                                    ) in order_later_time_slots" :key="key" :value="
                                      item.start_time + ' - ' + item.end_time
                                    " @click="
  setSelectedTimeSlot(
    item.start_time + ' - ' + item.end_time,
    item.start_time
  )
">
                                    {{
                                        item.start_time + " - " + item.end_time
                                    }}
                                  </b-dropdown-item>
                                </b-dropdown>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div style="margin-top: auto; margin-bottom: auto">
                          <div
                            class="col-md-12 col-xs-12 col-sm-12"
                            style="padding-right: 5px; padding-left: 5px"
                          >
                            <b-form-checkbox
                              id="checkbox-1"
                              v-model="digi_order_type"
                              @change="changeDigiOrderType"
                              name="checkbox-1"
                            >
                              Order Later
                            </b-form-checkbox>
                             <label for=""
                              >Order Later Date and Time
                              {{ `${datetimeEmpty + ":" + ordertime}` }}
                              <b-icon-pencil-fill
                                @click="changeOrderLaterDateTimeCheck"
                                style="margin-left: 5px; font-size: 16px"
                              ></b-icon-pencil-fill>
                            </label>
                          </div>

                         <div
                            v-if="order_type == 1 || getOrderLater === true"
                            class="col-md-4 col-xs-12 col-sm-12"
                            style="padding-right: 5px; padding-left: 5px"
                          >
                            <datetime
                              style="
                                margin-right: 5px;
                                margin-left: 5px;
                                pointer-events: none;
                              "
                              type="date"
                              v-model="datetimeEmpty"
                              input-class="my-class"
                              zone="Asia/Kolkata"
                              :format="{
                                year: 'numeric',
                                month: 'numeric',
                                day: 'numeric',
                              }"
                              :phrases="{ ok: 'Ok', cancel: 'Exit' }"
                              :week-start="7"
                              :min-datetime="minDatetime"
                              :max-datetime="maxDatetime"
                              placeholder="Select Date"
                              @change="validateDate"
                              readonly
                            ></datetime>
                          </div>
                          <div
                            v-if="order_type == 1 || getOrderLater === true"
                            class="col-md-4 col-xs-12 col-sm-12"
                          >
                            <datetime
                              input-class="my-class"
                              style="
                                margin-right: 5px;
                                margin-left: 5px;
                                pointer-events: none;
                              "
                              type="time"
                              value-zone="Asia/Kolkata"
                              zone="Asia/Kolkata"
                              :format="{ hour: 'numeric', minute: 'numeric' }"
                              @change="validateTime"
                              placeholder="Select Time"
                              use12-hour
                              auto
                              v-model="ordertime"
                              readonly
                            >
                            </datetime>
                          </div>
                        </div> -->
                        <br />
                        <br />
                        <br />
                        <b-alert style="margin-top: auto; margin-bottom: auto" v-if="
                          deliverytype == 'dinein' &&
                          digital_order_setting.order_limit_dinein > 0 &&
                          digital_order_setting.order_limit_pickup != null
                        " show variant="warning">Minimum order amount is {{ currency_symbol
}}{{
    digital_order_setting.order_limit_dinein
}}</b-alert>

                        <b-alert style="margin-top: auto; margin-bottom: auto" v-if="
                          deliverytype == 'pickup' &&
                          digital_order_setting.order_limit_pickup > 0 &&
                          digital_order_setting.order_limit_pickup != null
                        " show variant="warning">Minimum order amount is {{ currency_symbol
}}{{
    digital_order_setting.order_limit_pickup
}}</b-alert>

                        <b-alert style="margin-top: auto; margin-bottom: auto" v-if="
                          deliverytype == 'delivery' &&
                          digital_order_setting.order_limit_delivery > 0 &&
                          digital_order_setting.order_limit_delivery != null
                        " show variant="warning">Minimum order amount is {{ currency_symbol
}}{{
    digital_order_setting.order_limit_delivery
}}</b-alert>
                        <br />
                      </div>
                      <div style="margin-top: auto; margin-bottom: auto" class="col-sm-4">
                        <div class="summary">
                          <div class="check_summry_name">
                            <p style="font-weight: bold">Subtotal</p>

                            <!-- <p
                              v-if="
                                cartGST.is_devidable == 1 && cartGST.gstper != 0
                              "
                            >
                              CGST ({{ cartGST.tax }})
                            </p>
                            <p
                              v-if="
                                cartGST.is_devidable == 1 && cartGST.gstper != 0
                              "
                            >
                              SGST ({{ cartGST.tax }})
                            </p> -->
                            <p v-if="
                              cartGST.is_devidable == 0 && cartGST.gstper != 0
                            ">
                              VAT ({{ cartGST.gstper }})
                            </p>
                            <p v-if="getAdditionalCharges.length > 0">
                              <span style="font-weight: bold">Charges</span>
                              <br />

                              <span v-for="(charge, index) in getAdditionalCharges" :key="index">
                                <span>
                                  {{ charge.charge_name }} ({{
                                      charge.charge_type
                                  }})
                                </span>
                                <span v-if="
                                  getOrderType === 'delivery' &&
                                  charge.delivery_applicable_platform == 1
                                ">
                                  Distance {{ getDistance }}
                                </span>
                                <span v-if="charge.tax_on_additional_tax != 0">-Tax ({{ charge.tax_amount }}%)</span>
                                <br />
                              </span>
                            </p>
                            <p v-if="getAdditionalCharges.length > 0" style="font-weight: bold">
                              Charges Total
                            </p>
                          </div>

                          <div class="check_summry_price">
                            <p style="text-align: left">
                              {{ currency_symbol }}.
                              {{
                                  Math.round(
                                    (cartTotalPrice + Number.EPSILON) * 100
                                  ) / 100
                              }}
                            </p>
                            <p style="text-align: left" v-if="
                              cartGST.is_devidable == 1 && cartGST.gstper != 0
                            ">
                              {{ currency_symbol }}.
                              {{ cartGST.cgst.toFixed(2) }}
                            </p>
                            <p style="text-align: left" v-if="
                              cartGST.is_devidable == 1 && cartGST.gstper != 0
                            ">
                              {{ currency_symbol }}.
                              {{ cartGST.sgst.toFixed(2) }}
                            </p>
                            <p style="text-align: left" v-if="
                              cartGST.is_devidable == 0 && cartGST.gstper != 0
                            ">
                              {{ currency_symbol }}.
                              {{ (cartGST.cgst + cartGST.sgst).toFixed(2) }}
                            </p>
                            <br />
                            <p v-if="getAdditionalCharges.length > 0" style="text-align: left; margin-top: 9px">
                              <span v-for="(charge, index) in getAdditionalCharges" :key="index">
                                {{ currency_symbol }}.
                                {{
                                    Math.round(
                                      (charge.total + Number.EPSILON) * 100
                                    ) / 100
                                }}
                                <br />
                              </span>
                              <br />
                              <span v-for="(charge, index) in getAdditionalCharges" :key="index">
                                <span v-if="
                                  getAdditionalCharges.length - 1 === index
                                ">
                                  {{ currency_symbol }}.
                                  {{
                                      Math.round(
                                        (charge.finaltotal + Number.EPSILON) * 100
                                      ) / 100
                                  }}
                                </span>
                              </span>
                              <!--
                                             <span>
                                                   {{Math.round(((getItemLevelTotalCharge()) + Number.EPSILON) * 100) / 100}}
                                             </span>-->

                              <!--<span v-for="(item, index) in cartItems" :key="index">


                                             <span v-for="(charge, index) in item.add_charge" :key="index">
                                                <span>
                                                   {{currency_symbol}}. {{charge.calculated_charge_amt}}
                                                </span>
                                             </span>
                                             
                                             </span> -->
                            </p>
                          </div>
                        </div>
                        <div style="float: left; width: 100%" class="summary_total">
                          <div class="check_summry_total_name">
                            <p v-if="applied_promo_disc_amt > 0" style="font-weight: bold">
                              Discount
                            </p>
                            <p style="font-weight: bold">Total</p>
                          </div>
                          <div style="width: 60px !important" class="check_summry_total_price"></div>
                          <div class="check_summry_total_price">
                            <p v-if="applied_promo_disc_amt > 0" style="text-align: left">
                              {{ currency_symbol }}.{{ applied_promo_disc_amt }}
                            </p>
                            <p style="text-align: left" v-if="getAdditionalCharges.length > 0">
                              {{ currency_symbol }}.
                              <span v-for="(charge, index) in getAdditionalCharges" :key="index">
                                <span v-if="
                                  index == getAdditionalCharges.length - 1
                                ">
                                  <span v-if="cartGST.tax_inex_method == 1">
                                    {{
                                        Math.round(
                                          (cartTotalPrice +
                                            charge.total -
                                            applied_promo_disc_amt +
                                            Number.EPSILON) *
                                          100
                                        ) / 100
                                    }}
                                  </span>
                                  <span v-if="cartGST.tax_inex_method == 0">
                                    {{
                                        Math.round(
                                          (cartTotalPrice +
                                            cartGST.cgst +
                                            cartGST.sgst +
                                            charge.total -
                                            applied_promo_disc_amt +
                                            Number.EPSILON) *
                                          100
                                        ) / 100
                                    }}
                                  </span>
                                </span>
                              </span>
                            </p>
                            <p style="text-align: left" v-if="getAdditionalCharges.length == 0">
                              {{ currency_symbol }}.
                              <span v-if="cartGST.tax_inex_method == 1">
                                {{
                                    Math.round(
                                      (cartTotalPrice -
                                        applied_promo_disc_amt +
                                        Number.EPSILON) *
                                      100
                                    ) / 100
                                }}
                              </span>
                              <span v-if="cartGST.tax_inex_method == 0">
                                {{
                                    Math.round(
                                      (cartTotalPrice +
                                        cartGST.cgst +
                                        cartGST.sgst -
                                        applied_promo_disc_amt +
                                        Number.EPSILON) *
                                      100
                                    ) / 100
                                }}
                              </span>
                            </p>
                          </div>
                          <!--<label v-if="cartGST.tax_inex_method == 1" style="text-align: center;color: #EC7063;">Note: Total amount included with tax</label>
                                       <label v-if="cartGST.tax_inex_method == 0" style="text-align: center;color: #EC7063;">Note: Total amount not include in tax</label>-->
                        </div>
                      </div>

                      <label style="text-align: center; color: #ec7063; width: 33%">Inclusive of all Taxes</label>
                    </div>
                    <div class="checkout_add">
                      <input type="button" name="btn_next" value="NEXT" class="btn_checkout_next"
                        @click="addclass(2)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel panel-default">
            <div class="panel-heading-h2">
              <h4 class="panel-title">
                <!-- <a style="font-size:25px;" ng-click="contact_detail()">Contact Details</a> -->
                <a style="color: #fff" type="button" @click="addclass(2)" class="btn">Contact Details</a>
              </h4>
            </div>
            <div id="collapse2" class="panel-collapse" :class="classofaccord2">
              <div class="panel-body">
                <div class="order_conatct_details">
                  <b-form-input style="margin: 10px" id="user_name" placeholder="Name" v-model="user_name" type="text">
                  </b-form-input>
                  <b-form-input style="margin: 10px" id="user_mobile" placeholder="Mobile Number" v-model="user_mobile"
                    type="text">
                  </b-form-input>
                  <!--   <b-form-input 
                              style="margin:10px" 
                              id="user_email" 
                              placeholder="Email Address"
                              v-model="user_email"
                              type="text">
                              </b-form-input> -->
                  <b-form-input style="margin: 10px; display: none" id="user_address"
                    placeholder="Address (For Home Delivery)" v-model="user_address" type="text">
                  </b-form-input>
                  <!--  <b-form-input 
                              style="margin:10px" 
                              id="user_pin_code" 
                              placeholder="Pin Code"
                              v-model="user_pin_code"
                              type="number">
                              </b-form-input>-->
                  <b-form-input readonly style="margin: 10px" id="user_select_outlet" placeholder="Outlet Name"
                    v-model="user_select_outlet" type="text">
                  </b-form-input>
                  <b-form-input readonly style="margin: 10px" id="user_select_del_address"
                    placeholder="Delivery Address" v-model="user_select_del_address" type="text">
                  </b-form-input>
                </div>
                <input type="button" name="btn_next" value="NEXT" @click="addclass(3)" class="btn_checkout_next" />
                <div class="clearfix"></div>
                <hr />
              </div>
            </div>
          </div>
          <div class="panel panel-default">
            <div class="panel-heading-h2">
              <h4 class="panel-title">
                <a style="color: #fff" type="button" @click="addclass(3)" class="btn">Payment</a>
                <!-- <a ng-click="" style="font-size:25px;">Payment Details</a> -->
              </h4>
            </div>
            <div id="collapse3" class="panel-collapse" :class="classofaccord3">
              <div class="panel-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-xs-3 col-sm-3 col-lg-3 usewalletmoneymobile">
                      <div class="usewalletmoney">
                        <div class="table-responsive transctiodata">
                          <table>
                            <tr>
                              <td>Cart Total</td>
                              <td>
                                <p v-if="getAdditionalCharges.length > 0">
                                  {{ currency_symbol }}.
                                  <span v-for="(
                                      charge, index
                                    ) in getAdditionalCharges" :key="index">
                                    <span v-if="
                                      index == getAdditionalCharges.length - 1
                                    ">
                                      <span v-if="cartGST.tax_inex_method == 1">
                                        {{
                                            Math.round(
                                              (cartTotalPrice +
                                                charge.total -
                                                applied_promo_disc_amt +
                                                Number.EPSILON) *
                                              100
                                            ) / 100
                                        }}
                                      </span>
                                      <span v-if="cartGST.tax_inex_method == 0">
                                        {{
                                            Math.round(
                                              (cartTotalPrice +
                                                cartGST.cgst +
                                                cartGST.sgst +
                                                charge.total -
                                                applied_promo_disc_amt +
                                                Number.EPSILON) *
                                              100
                                            ) / 100
                                        }}
                                      </span>
                                    </span>
                                  </span>
                                </p>
                                <p v-if="getAdditionalCharges.length == 0">
                                  {{ currency_symbol }}.
                                  <span v-if="cartGST.tax_inex_method == 1">
                                    {{
                                        Math.round(
                                          (cartTotalPrice -
                                            applied_promo_disc_amt +
                                            Number.EPSILON) *
                                          100
                                        ) / 100
                                    }}
                                  </span>
                                  <span v-if="cartGST.tax_inex_method == 0">
                                    {{
                                        Math.round(
                                          (cartTotalPrice +
                                            cartGST.cgst +
                                            cartGST.sgst -
                                            applied_promo_disc_amt +
                                            Number.EPSILON) *
                                          100
                                        ) / 100
                                    }}
                                  </span>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>Discount Amount</td>
                              <td>
                                <p style="margin: 0px">
                                  {{ currency_symbol }}.{{
                                      applied_promo_disc_amt
                                  }}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>Payble amount</td>
                              <td>
                                <p v-if="getAdditionalCharges.length > 0">
                                  {{ currency_symbol }}.
                                  <span v-for="(
                                      charge, index
                                    ) in getAdditionalCharges" :key="index">
                                    <span v-if="
                                      index == getAdditionalCharges.length - 1
                                    ">
                                      <span v-if="cartGST.tax_inex_method == 1">
                                        {{
                                            Math.round(
                                              (cartTotalPrice +
                                                charge.total -
                                                applied_promo_disc_amt +
                                                Number.EPSILON) *
                                              100
                                            ) / 100
                                        }}
                                      </span>
                                      <span v-if="cartGST.tax_inex_method == 0">
                                        {{
                                            Math.round(
                                              (cartTotalPrice +
                                                cartGST.cgst +
                                                cartGST.sgst +
                                                charge.total -
                                                applied_promo_disc_amt +
                                                Number.EPSILON) *
                                              100
                                            ) / 100
                                        }}
                                      </span>
                                    </span>
                                  </span>
                                </p>
                                <p v-if="getAdditionalCharges.length == 0">
                                  {{ currency_symbol }}.
                                  <span v-if="cartGST.tax_inex_method == 1">
                                    {{
                                        Math.round(
                                          (cartTotalPrice -
                                            applied_promo_disc_amt +
                                            Number.EPSILON) *
                                          100
                                        ) / 100
                                    }}
                                  </span>
                                  <span v-if="cartGST.tax_inex_method == 0">
                                    {{
                                        Math.round(
                                          (cartTotalPrice +
                                            cartGST.cgst +
                                            cartGST.sgst -
                                            applied_promo_disc_amt +
                                            Number.EPSILON) *
                                          100
                                        ) / 100
                                    }}
                                  </span>
                                </p>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-6 col-sm-6 col-lg-6 paymentonlineoptionmobi">
                      <div class="paymentonlineoption">
                        <div class="payment_radio" v-for="(pay, index) in pay_methods" :key="index">
                          <b-form-radio @change="filterChangedPay(selected_payment_mode)" style="display: inline-block"
                            v-model="selected_payment_mode" :value="pay.value" inline>
                            {{ pay.text }}
                          </b-form-radio>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="checkout_add">
                  <button style="background-color: #ffbb0e; color: #fff" v-if="
                    selected_payment_mode != null &&
                    (selected_payment_mode == 0 ||
                      selected_payment_mode == 3 ||
                      selected_payment_mode == 5)
                  " @click="placeOrder" class="btn btn-warning btn_checkout_online">
                    Place Order
                  </button>
                  <button style="background-color: #ffbb0e; color: #fff" v-if="
                    selected_payment_mode != null &&
                    (selected_payment_mode == 2 ||
                      selected_payment_mode == 1 ||
                      selected_payment_mode == 4)
                  " @click="placeOrder" class="btn btn-warning btn_checkout_online">
                    Pay Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ***************** end new design*********** -->
    </div>
    <Footer />
    <b-modal v-model="order_type_modal" hide-footer hide-header no-close-on-backdrop id="modal-center-order-type"
      class="modal fade centered-modal" title="Choose Order Type">
      <div class="modal-body">
        <header style="background-color: #343a40; color: #fff">
          <span @click="closeOptGrpModal" class="close-button topright">&times;</span>
        </header>
        <h5 style="font-size: 16px; padding-bottom: 10px">Choose Order Type</h5>
        <div v-for="outlet in outletInformation" :key="outlet.store_id">
          <b-form-radio style="display: inline-block; margin-left: 5px"
            v-if="outlet.digital_ordering_settings.other.dinein == 1" v-model="deliverytype" name="some-radios"
            value="dinein" @change="filterChanged(deliverytype)">Dine In</b-form-radio>
          <b-form-radio style="display: inline-block; margin-left: 5px"
            v-if="outlet.digital_ordering_settings.other.pickup == 1" v-model="deliverytype" name="some-radios"
            value="pickup" @change="filterChanged(deliverytype)">Pickup</b-form-radio>
          <b-form-radio style="display: inline-block; margin-left: 5px"
            v-if="outlet.digital_ordering_settings.other.delivery == 1" v-model="deliverytype" name="some-radios"
            value="delivery" @change="filterChanged(deliverytype)">Delivery</b-form-radio>
          <!-- <p>Order Delivery Limit: {{ outlet.digital_ordering_settings.customer.delivery_within_limit }} </p>
                  -->
          <br />
          <br />
          <!--  <MapComponent
            v-if="deliverytype == 'delivery'"
            v-bind:storelat="outlet.geo_latitude"
            v-bind:storelng="outlet.geo_longitude"
            v-bind:deliverylimit="
              outlet.digital_ordering_settings.customer.delivery_within_limit
            "
          /> -->
        </div>
        <div class="mt-3" v-if="deliverytype == null" style="color: red">
          <strong>{{ error }}</strong>
        </div>
        <b-form-input v-if="deliverytype == 'dinein'" v-model="table_room_no"
          style="margin: 10px; display: inline-block; margin-left: 5px" id="usernote" placeholder="Enter Table/Room No"
          type="text">
        </b-form-input>
        <b-button style="background-color: #ffbb0e; color: #fff" class="mt-3" variant="outline-danger" block
          @click="closeModal">Confirm & Proceed</b-button>
      </div>
    </b-modal>

    <b-modal v-model="showModal" ref="modal-center-manual-address" hide-footer hide-header no-close-on-backdrop
      id="modal-center-manual-address" class="modal fade centered-modal" title="Choose Order Type">
      <div class="modal-body">
        <header style="background-color: #343a40; color: #fff">
          <span @click="closemanualAddress" class="close-button topright">&times;</span>
        </header>
        <h5 style="font-size: 18px; padding-bottom: 10px">
          Add new delivery address
        </h5>

        <div class="savedaddress-modal">
          <div class="add-address-container">
            <div class="address">
              <div>
                <div style="float: left" class="content">
                  <h5 style="font-size: 16px">Your Location :</h5>
                  <p style="font-size: 15px; font-weight: 700">
                    {{ add_google_address }}
                    <span><button @click="mapModal('create')">
                        <i class="fa fa-pencil"></i></button></span>
                  </p>
                </div>
              </div>
              <div></div>
            </div>

            <br />
            <br />
            <br />
            <br />
            <br />
            <form class="form">
              <b-form-input v-model="comp_address" style="margin: 10px" id="number" placeholder="Complete address"
                type="text">
              </b-form-input>
              <b-form-input v-model="building_tower" style="margin: 10px" id="number" placeholder="Building/Tower"
                type="text">
              </b-form-input>

              <b-form-input v-model="landmark" style="margin: 10px" id="number" placeholder="Landmark (Optional)"
                type="text">
              </b-form-input>

              <div class="jss28 chips-group form-group">
                <label class="form-label" for="addressForm.ControlInput3">Location Label :</label>
                <b-form-radio v-model="loc_label" style="display: inline-block; margin-left: 5px" name="some-radios"
                  value="Home" @change="changeLocLabel('Home')">Home</b-form-radio>
                <b-form-radio v-model="loc_label" style="display: inline-block; margin-left: 5px" name="some-radios"
                  value="Work" @change="changeLocLabel('Work')">Work</b-form-radio>
                <b-form-radio v-model="loc_label" style="display: inline-block; margin-left: 5px" name="some-radios"
                  value="Other" @change="changeLocLabel('Other')">Other</b-form-radio>
              </div>
              <b-button style="background-color: #ffbb0e; color: #fff" class="mt-3" variant="outline-danger" block
                @click="addNewAddress">Save & Proceed</b-button>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal hide-footer hide-header no-close-on-backdrop id="modal-center-show-address"
      class="modal fade centered-modal" title="Choose Order Type">
      <div class="modal-body">
        <header style="background-color: #343a40; color: #fff">
          <span @click="closeshowAddress" class="close-button topright">&times;</span>
        </header>
        <h5 style="font-size: 18px; padding-bottom: 10px; margin-bottom: 20px">
          Select Address
        </h5>

        <h6 style="font-size: 15px; padding-bottom: 10px">Saved Addresses</h6>

        <div v-for="user in userinfolocal.address" :key="user.id">
          <div v-if="user.is_default == 0" class="address-list list-group" @click="setDefault(user)">
            <div style="margin-top: 5px; width: 100%" class="list-group-item">
              <div class="d-flex saved-address">
                <h5 class="address-label home" style="font-size: 17px; font-weight: 700">
                  {{ user.label }}
                  <span v-if="user.is_default == 1" class="badge1 badge-secondary">Default</span>
                </h5>

                <span class="MuiButtonBase-root MuiIconButton-root">
                  <b-button v-if="user.is_default == 0" @click="setDefault(user)" variant="outline-danger" class="mt-3"
                    style="
                      padding-left: 5px;
                      padding-right: 10px;
                      font-size: 13px;
                      background-color: #000;
                      color: #fff;
                      margin-right: 5px;
                    "><i class="fa fa-check"></i>
                  </b-button>
                  <b-button @click="changeAddressModal(user)" variant="outline-danger" class="mt-3" style="
                      padding-left: 5px;
                      padding-right: 10px;
                      font-size: 13px;
                      background-color: #000;
                      color: #fff;
                      margin-right: 5px;
                    "><i class="fa fa-pencil"></i></b-button>
                  <b-button v-if="user.is_default == 0" @click="deleteAdd(user.id)" variant="outline-danger"
                    class="mt-3" style="
                      padding-left: 5px;
                      padding-right: 10px;
                      font-size: 13px;
                      background-color: #000;
                      color: #fff;
                    "><i class="fa fa-trash"></i></b-button>
                </span>
              </div>
              <h5 style="font-size: 16px; margin-top: 20px; margin-bottom: 20px">
                {{ user.manual_address }}, {{ user.floor }}, {{ user.landmark }}
              </h5>
            </div>
          </div>

          <div v-else class="address-list list-group">
            <div style="margin-top: 5px; width: 100%" class="list-group-item">
              <div class="d-flex saved-address">
                <h5 class="address-label home" style="font-size: 17px; font-weight: 700">
                  {{ user.label }}
                  <span v-if="user.is_default == 1" class="badge1 badge-secondary">Default</span>
                </h5>

                <span class="MuiButtonBase-root MuiIconButton-root">
                  <b-button v-if="user.is_default == 0" @click="setDefault(user)" variant="outline-danger" class="mt-3"
                    style="
                      padding-left: 5px;
                      padding-right: 10px;
                      font-size: 13px;
                      background-color: #000;
                      color: #fff;
                      margin-right: 5px;
                    "><i class="fa fa-check"></i>
                  </b-button>
                  <b-button @click="changeAddressModal(user)" variant="outline-danger" class="mt-3" style="
                      padding-left: 5px;
                      padding-right: 10px;
                      font-size: 13px;
                      background-color: #000;
                      color: #fff;
                      margin-right: 5px;
                    "><i class="fa fa-pencil"></i></b-button>
                  <b-button v-if="user.is_default == 0" @click="deleteAdd(user.id)" variant="outline-danger"
                    class="mt-3" style="
                      padding-left: 5px;
                      padding-right: 10px;
                      font-size: 13px;
                      background-color: #000;
                      color: #fff;
                    "><i class="fa fa-trash"></i></b-button>
                </span>
              </div>
              <h5 style="font-size: 16px; margin-top: 20px; margin-bottom: 20px">
                {{ user.manual_address }}, {{ user.floor }}, {{ user.landmark }}
              </h5>
            </div>
          </div>
        </div>

        <button @click="mapModal('create')" class="add-address-button">
          + Add address
        </button>
      </div>
    </b-modal>

    <b-modal hide-footer hide-header no-close-on-backdrop id="modal-center-change-address"
      class="modal fade centered-modal" title="Choose Order Type">
      <div class="modal-body">
        <header style="background-color: #343a40; color: #fff">
          <span @click="closechangeAddress" class="close-button topright">&times;</span>
        </header>
        <h5 style="font-size: 18px; padding-bottom: 10px">
          Edit delivery address
        </h5>

        <div class="savedaddress-modal">
          <div class="add-address-container">
            <div class="address">
              <div>
                <div style="float: left" class="content">
                  <h5 style="font-size: 16px">Your Location :</h5>
                  <p style="font-size: 16px; font-weight: 700">
                    {{ add_google_address }}

                    <span><button @click="mapModal('edit')">
                        <i class="fa fa-pencil"></i></button></span>
                  </p>
                </div>
              </div>
              <div></div>
            </div>

            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <form class="form">
              <b-form-input v-model="comp_address_edit" style="margin: 10px" id="number" placeholder="Complete address"
                type="text">
              </b-form-input>
              <b-form-input v-model="building_tower_edit" style="margin: 10px" id="number" placeholder="Building/Tower"
                type="text">
              </b-form-input>

              <b-form-input v-model="landmark_edit" style="margin: 10px" id="number" placeholder="Landmark (Optional)"
                type="text">
              </b-form-input>

              <b-form-input v-model="add_id" style="margin: 10px; display: none" id="number"
                placeholder="Landmark (Optional)" type="text">
              </b-form-input>

              <b-form-input v-model="add_lat" style="margin: 10px; display: none" id="number"
                placeholder="Landmark (Optional)" type="text">
              </b-form-input>

              <b-form-input v-model="add_lng" style="margin: 10px; display: none" id="number"
                placeholder="Landmark (Optional)" type="text">
              </b-form-input>

              <div class="jss28 chips-group form-group">
                <label class="form-label" for="addressForm.ControlInput3">Location Label :</label>
                <b-form-radio v-model="loc_label_edit" style="display: inline-block; margin-left: 5px"
                  name="some-radios" value="Home" @change="changeLocLabel('Home')">Home</b-form-radio>
                <b-form-radio v-model="loc_label_edit" style="display: inline-block; margin-left: 5px"
                  name="some-radios" value="Work" @change="changeLocLabel('Work')">Work</b-form-radio>
                <b-form-radio v-model="loc_label_edit" style="display: inline-block; margin-left: 5px"
                  name="some-radios" value="Other" @change="changeLocLabel('Other')">Other</b-form-radio>
              </div>
              <b-button style="background-color: #ffbb0e; color: #fff" class="mt-3" variant="outline-danger" block
                @click="editManualAddress">Save & Proceed</b-button>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal hide-footer hide-header no-close-on-backdrop id="modal-center-map" class="modal fade centered-modal"
      title="Choose Order Type">
      <div class="modal-body">
        <header style="background-color: #343a40; color: #fff">
          <span @click="closeMapModal" class="close-button topright">&times;</span>
        </header>
        <h5 style="font-size: 18px; padding-bottom: 10px">
          Edit delivery address
        </h5>

        <div v-for="outlet in outletInformation" :key="outlet.store_id">
          <MapComponent v-bind:storelat="outlet.geo_latitude" v-bind:storelng="outlet.geo_longitude"
            v-bind:deliverylimit="
              outlet.digital_ordering_settings.customer.delivery_within_limit
            " />
        </div>

        <br />
        <br />
        <b-button style="background-color: #ffbb0e; color: #fff" block @click="changeMapLoc">Confirm & Proceed
        </b-button>
      </div>
    </b-modal>

    <form id="myForm" action="https://secure.payu.in/_payment" method="post">
      <input type="hidden" name="key" v-model="payu_key" />
      <input type="hidden" name="txnid" v-model="payu_txnid" />
      <input type="hidden" name="productinfo" v-model="payu_productinfo" />
      <input type="hidden" name="amount" v-model="payu_amount" />
      <input type="hidden" name="email" v-model="payu_email" />
      <input type="hidden" name="firstname" v-model="payu_firstname" />
      <input type="hidden" name="surl" v-model="payu_surl" />
      <input type="hidden" name="furl" v-model="payu_furl" />
      <input type="hidden" name="phone" v-model="payu_phone" />
      <input type="hidden" name="hash" v-model="payu_hash" />
    </form>
  </div>
</template>



<script>
import Header from "./Header";
import Footer from "./Footer";
import Location from "./Location";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";

import moment from "moment";
import $ from "jquery";
import defaultimg from "../assets/images/default.jpeg";
import MapComponent from "./MapComponent";

import * as VueGoogleMaps from "vue2-google-maps";
import Cart from "./Cart.vue";

export default {
  name: "Checkout",
  components: {
    Header,
    Footer,
    datetime: Datetime,
    MapComponent,
  },
  mixins: [Footer, Header, Location, Cart],
  data () {
    return {
      defaultimg,
      order_type_modal: false,
      applied_promo_disc_amt: localStorage.getItem("coupan_discount")
        ? localStorage.getItem("coupan_discount")
        : 0,
      user_name: "",
      user_mobile: "",
      user_email: "",
      user_address: "",
      user_pin_code: "",
      user_select_outlet: "",
      user_select_del_address: "",
      deliverytype: localStorage.getItem("deliverytype"),
      pay_option: "cash",
      pay_methods: [],
      selected_payment_mode: null,
      usernote: "",
      razorpay_key: "",
      outlet_name: "",
      minDatetime: "",
      maxDatetime: "",
      datetimeEmpty: "",
      ordertime: "",
      digi_order_type: 0,
      order_type: 0,
      classofaccord1: "",
      classofaccord2: "collapse",
      classofaccord3: "collapse",
      userinfolocal: localStorage.getItem("userinfo")
        ? JSON.parse(localStorage.getItem("userinfo"))
        : [],

      payu_key: "",
      payu_txnid: "",
      payu_productinfo: "",
      payu_amount: "",
      payu_email: "",
      payu_firstname: "",
      payu_lastname: "",
      payu_surl: "",
      payu_furl: "",
      payu_phone: "",
      payu_hash: "",
      comp_address: "",
      building_tower: "",
      landmark: "",
      loc_label: "",

      comp_address_edit: "",
      building_tower_edit: "",
      landmark_edit: "",
      loc_label_edit: "",
      add_id: "",
      add_google_address: "",
      add_lat: "",
      add_lng: "",
      mapModal_val: "",
      boxTwo: "",
      currentCartItemCount: 0,
      showModal: false,
      coupon_code_name: localStorage.getItem("coupon_code_name")
        ? localStorage.getItem("coupon_code_name")
        : "",
      coupan_code_amt: localStorage.getItem("coupan_discount")
        ? localStorage.getItem("coupan_discount")
        : 0,
      coupon_code_type: localStorage.getItem("coupon_code_type")
        ? localStorage.getItem("coupon_code_type")
        : "",
      code_id: localStorage.getItem("coupan_code_id")
        ? localStorage.getItem("coupan_code_id")
        : "",
      order_later: localStorage.getItem("order_later")
        ? localStorage.getItem("order_later")
        : false,
      order_now: localStorage.getItem("order_now")
        ? localStorage.getItem("order_now")
        : true,
      order_later_time_slots: "",
      selected_order_time_slots: localStorage.getItem(
        "selected_order_time_slots"
      )
        ? localStorage.getItem("selected_order_time_slots")
        : "Select Time",
      order_later_start_time: "",
    };
  },
  computed: {
    ...mapGetters(["cartItems"]),
    ...mapGetters(["outletInformation"]),
    ...mapGetters(["getOrderType"]),
    ...mapGetters(["cartGST"]),
    ...mapGetters(["additionalCharges"]),
    ...mapGetters(["getAdditionalCharges"]),
    ...mapGetters(["cartTotalPrice"]),
    ...mapGetters(["cartItemCount"]),
    ...mapGetters(["setOutletName"]),
    ...mapGetters(["currency_symbol"]),
    ...mapGetters(["digital_order_setting"]),
    ...mapGetters(["getDistance"]),
    ...mapGetters(["getOrderLater"]),
    ...mapGetters(["getOrderNow"]),
    ...mapGetters(["getOrderDate"]),
    ...mapGetters(["getOrderTime"]),
    google: VueGoogleMaps.gmapApi,
  },
  methods: {
    setSelectedTimeSlot (value, start_time) {
      var today = new Date();
      var day = today.getDate();
      var month = today.getMonth() + 1;
      var year = today.getFullYear();

      // alert("year is " + year + "/" + month + "/" + day);

      // this.datetimeEmpty = year + "/" + month + "/" + day;

      //this.datetimeEmpty = year + "/" + month + "/" + day;
      let tempdt = year + "-" + month + "-" + day;
      //console.log("tempdt ", tempdt);
      this.selected_order_time_slots = value;
      this.order_later_start_time = value;
      //2021-11-29T19:15:00.000+05:30
      //2021-11-30T09:30:00.000+05:30
      //2021-11-29T11:45:00.000+05:30
      var dt = moment(start_time, ["h:mm A"]).format("HH:mm");
      //console.log("dt ", dt);
      var temptime = tempdt + "T" + dt + ":00.000+05:30";

      //console.log("temptime ", temptime);
      /* var todayTime = new Date(temptime);
      var h = todayTime.getHours();
      var m = todayTime.getMinutes();
      //  var s = today.getSeconds();
      var now = h + ":" + m + ":" + "00";
      // console.log("today ", now); */

      this.ordertime = temptime;
      localStorage.setItem(
        "selected_order_time_slots",
        this.selected_order_time_slots
      );
      localStorage.setItem("ordertime", this.ordertime);
      localStorage.setItem(
        "order_later_start_time",
        this.order_later_start_time
      );
    },

    closeModalOrderLaterCheckout () {
      localStorage.removeItem("order_later");
      localStorage.removeItem("order_now");
      localStorage.removeItem("ordertime");
      localStorage.removeItem("orderdate");

      if (this.order_later == true && this.datetimeEmpty == "") {
        this.$bvToast.toast("Please enter valid date for Order Later", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.order_later == true && this.ordertime == "") {
        this.$bvToast.toast("Please enter valid time for Order Later", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      this.$store.dispatch("saveOrderLater", {
        order_later: this.order_later,
      });
      this.$store.dispatch("saveOrderNow", {
        order_now: this.order_now,
      });

      var today = new Date(this.datetimeEmpty);
      var day = today.getDate();
      var month = today.getMonth() + 1;
      var year = today.getFullYear();

      // alert("year is " + year + "/" + month + "/" + day);

      this.datetimeEmpty = year + "/" + month + "/" + day;

      this.datetimeEmpty = year + "/" + month + "/" + day;
      this.orderdatetoshow = day + "/" + month + "/" + year;

      var todayTime = new Date(this.ordertime);
      var h = todayTime.getHours();
      var m = todayTime.getMinutes();
      //  var s = today.getSeconds();
      var now = h + ":" + m + ":" + "00";

      //  alert("Now is "+now)

      /*  var format = "hh:mm:ss";
      var time = moment(now, format);
      var beforeTime = moment(
        this.digital_order_setting.day_start_time,
        format
      );
      var afterTime = moment(this.digital_order_setting.day_close_time, format); */

      this.ordertime = now;
      /* if (time.isBetween(beforeTime, afterTime)) {
        //alert('is between '+now)
       
      } else {
        //alert('is not between')

        this.ordertime = "";
        this.$bvToast.toast("Please Select Another time.", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      } */

      // alert(this.ordertime);
      //  alert(this.datetimeEmpty);

      if (this.order_later == false) {
        this.ordertime = "";
        this.datetimeEmpty = "";
      }

      this.$store.dispatch("saveOrderDate", {
        order_date: this.datetimeEmpty,
      });
      this.$store.dispatch("saveOrderTime", {
        order_time: this.ordertime,
      });

      localStorage.setItem("order_later", this.order_later);
      localStorage.setItem("order_now", this.order_now);

      localStorage.setItem("ordertime", this.ordertime);
      localStorage.setItem("orderdate", this.datetimeEmpty);
      this.$bvModal.hide("modal-center-order-later");
    },
    closeModalOrderLaterCloseCheck () {
      // alert(this.datetimeEmpty);
      this.$bvModal.hide("modal-center-order-later");
    },
    orderTimeOptionCheckout (value) {
      //alert(value);
      if (value === "later") {
        this.order_later = true;
        this.order_now = false;
        this.$store.dispatch("saveOrderLater", {
          order_later: this.order_later,
        });
        this.$store.dispatch("saveOrderNow", {
          order_now: this.order_now,
        });
      }

      if (value === "now") {
        this.order_later = false;
        this.order_now = true;
        this.$store.dispatch("saveOrderLater", {
          order_later: this.order_later,
        });
        this.$store.dispatch("saveOrderNow", {
          order_now: this.order_now,
        });
      }
    },
    getItemLevelTotalCharge () {
      //alert("HEllo")
      let item_level_total_charge = 0;

      /*<span v-for="(item, index) in cartItems" :key="index">


                                             <span v-for="(charge, index) in item.add_charge" :key="index">
                                                <span>
                                                   {{currency_symbol}}. {{charge.calculated_charge_amt}}
                                                </span>
                                             </span>
                                             
                                             </span> */

      // alert("charge is "+ JSON.stringify(this.cartItems))

      // alert(JSON.stringify(this.cartItems))

      //  console.log(item_level_total_charge)

      return item_level_total_charge;
    },
    changeOrderLaterDateTimeCheck () {
      this.$bvModal.show("modal-center-order-later");

      //this.datetimeEmpty = this.getOrderDate;
    },
    setDefault (address) {
      //alert("Hello")
      this.userinfolocal.address.forEach((item) => {
        if (item.id == address.id) {
          item["is_default"] = 1;

          localStorage.setItem("del_address", item.google_address);
          //alert("del_address setDefault "+item.google_address)

          let storelat = localStorage.getItem("storelat");
          let storelng = localStorage.getItem("storelng");

          // alert('latitude is '+ storelat + ' longitude is '+ storelng)

          let userlat = item.latitude;
          let userlng = item.longitude;
          let useraddress = item.google_address;
          let storeAddress;
          this.outletInformation.find((outlet) => {
            storeAddress = outlet.address;
          });
          let currentObj = this;
          const service = new currentObj.google.maps.DistanceMatrixService(); //new VueGooglemaps.maps.DistanceMatrixService()

          const origin1 = {
            lat: parseFloat(storelat),
            lng: parseFloat(storelng),
          };
          const origin2 = storeAddress;
          const destinationA = useraddress;
          const destinationB = {
            lat: parseFloat(userlat),
            lng: parseFloat(userlng),
          };
          const request = {
            origins: [origin1, origin2],
            destinations: [destinationA, destinationB],
            travelMode: currentObj.google.maps.TravelMode.DRIVING,
            unitSystem: currentObj.google.maps.UnitSystem.METRIC,
            avoidHighways: false,
            avoidTolls: false,
          };

          service.getDistanceMatrix(request).then((response) => {
            // put response
            // alert((response.rows[0].elements[0].distance.value / 1000).toFixed(2))

            let finaldistance = (
              response.rows[0].elements[0].distance.value / 1000
            ).toFixed(2);

            this.$store.dispatch("saveDistance", {
              deliverydistance: finaldistance,
            });
            localStorage.setItem("deliverylocation", finaldistance);
            localStorage.setItem("userlat", userlat);
            localStorage.setItem("userlng", userlng);
          });

          this.$bvToast.toast("Default Addrees Changed", {
            variant: "success",
            toaster: "b-toaster-bottom-left",
            solid: true,
          });
          this.closeshowAddress();
        } else {
          item["is_default"] = 0;
        }
      });
    },

    mapModal (value) {
      this.mapModal_val = value;
      this.$bvModal.show("modal-center-map");
    },

    closeMapModal () {
      //alert('closeMapModal')
      this.$bvModal.hide("modal-center-map");
    },

    changeMapLoc () {
      //  let storelat = localStorage.getItem('storelat');
      //  let storelng = localStorage.getItem('storelng');

      // alert('latitude is '+ storelat + ' longitude is '+ storelng)

      //   let userlat = localStorage.getItem('userlat');
      //   let userlng = localStorage.getItem('userlng');

      /*        var R = 6371; // Radius of the earth in km
              var dLat = this.deg2rad(userlat-storelat);  // deg2rad below
              var dLon = this.deg2rad(userlng-storelng); 
              var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(this.deg2rad(storelat)) * Math.cos(this.deg2rad(userlat)) * 
                Math.sin(dLon/2) * Math.sin(dLon/2); 
              var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
              var d = R * c; // Distance in km
              var finaldistance = d.toFixed(2);

            localStorage.setItem("deliverylocation",finaldistance)*/
      //alert('deliverylimit is '+ deliverylimit)
      //alert('Distance is '+ finaldistance)

      /*
let storeAddress
            this.outletInformation.find(outlet => {
            

                    storeAddress = outlet.address
                 
                });

              const service = new this.google.maps.DistanceMatrixService() //new VueGooglemaps.maps.DistanceMatrixService()

              const origin1 = { lat: parseFloat(storelat), lng: parseFloat(storelng) };
              const origin2 = storeAddress;
              const destinationA = this.del_address;
              const destinationB = { lat: parseFloat(userlat), lng: parseFloat(userlng) };
              const request = {
                origins: [origin1, origin2],
                destinations: [destinationA, destinationB],
                travelMode: this.google.maps.TravelMode.DRIVING,
                unitSystem: this.google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                avoidTolls: false,
              };

                    service.getDistanceMatrix(request).then((response) => {
    // put response
   // alert((response.rows[0].elements[0].distance.value / 1000).toFixed(2))

        finaldistance = (response.rows[0].elements[0].distance.value / 1000).toFixed(2);
        
        localStorage.setItem("deliverylocation",finaldistance)

    });*/

      let currentObj = this;

      var finaldistance = localStorage.getItem("deliverylocation");
      let deliverylimit = localStorage.getItem("deliverylimit");

      if (parseFloat(finaldistance) > parseFloat(deliverylimit)) {
        //alert("finaldistance"+ finaldistance)
        currentObj.$bvToast.toast(`Sorry, Location is not servicable`, {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
          autoHideDelay: 2000,
        });
      } else {
        //alert("deliverylimit"+ deliverylimit)
        currentObj.add_google_address = localStorage.getItem("del_address");

        currentObj.closeMapModal();

        if (currentObj.mapModal_val === "create") {
          currentObj.manualAddress();
        } else {
          currentObj.add_lat = localStorage.getItem("userlat");
          currentObj.add_lng = localStorage.getItem("userlng");

          currentObj.changeAddressModal();
        }
      }
    },
    deg2rad (deg) {
      return deg * (Math.PI / 180);
    },
    manualAddress () {
      this.add_google_address = localStorage.getItem("del_address");
      //  this.$bvModal.show('modal-center-manual-address')

      this.showModal = true;
    },

    closemanualAddress () {
      // this.$bvModal.hide('modal-center-manual-address')
      //alert("Hello")
      //  this.$refs['modal-center-manual-address'].hide()
      this.showModal = false;
    },

    closeOptGrpModal () {
      this.$bvModal.hide("modal-center-order-type");
    },

    showAllAddress () {
      this.$bvModal.show("modal-center-show-address");
    },
    closeshowAddress () {
      this.$bvModal.hide("modal-center-show-address");
    },

    changeAddressModal (address) {
      this.closeshowAddress();
      /*
             {"id":65,"customer_phone":"8830427223","google_address":"Akurdi Railway Station Road, Nigdi, Pimpri-Chinchwad","manual_address":"Complete Address of customer edit","landmark":"Landmark of customer edit","floor":"Building Tower of customer edit","type":0,"label":"Home","is_default":0,"instructions":null,"latitude":"19.614302367267136","longitude":"74.6571698534424"}
              */
      this.$bvModal.show("modal-center-change-address");
      this.comp_address_edit = address.manual_address;
      this.building_tower_edit = address.floor;
      this.landmark_edit = address.landmark;
      this.loc_label_edit = address.label;
      this.add_id = address.id;
      this.add_google_address = address.google_address;
      this.add_lat = address.latitude;
      this.add_lng = address.longitude;
    },
    closechangeAddress () {
      this.$bvModal.hide("modal-center-change-address");
    },
    editManualAddress () {
      if (this.comp_address_edit == "") {
        this.$bvToast.toast("Please enter complete address", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.building_tower_edit == "") {
        this.$bvToast.toast("Please enter building/tower", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      let manual_address = {
        manual_address: this.comp_address_edit,
        customer_phone: this.userinfolocal.phone,
        google_address: this.add_google_address,
        landmark: this.landmark_edit,
        floor: this.building_tower_edit,
        label: this.loc_label_edit,
        latitude: this.add_lat,
        longitude: this.add_lng,
        is_default: 1,
        id: this.add_id,
      };

      let new_address = {
        store_id: this.userinfolocal.store_id,
        phone: this.userinfolocal.phone,
        action: "update",
        address: manual_address,
      };

      //alert(JSON.stringify(new_address))

      let currentObj = this;

      currentObj.axios
        .post("address/", new_address)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);

          if (status == 200) {
            //   alert(JSON.stringify(response.data.customer))

            localStorage.setItem(
              "userinfo",
              JSON.stringify(response.data.customer)
            );

            currentObj.$cookie.set(
              "test",
              JSON.stringify(response.data.customer),
              1
            );

            currentObj.userinfolocal = JSON.parse(
              localStorage.getItem("userinfo")
            );

            currentObj.comp_address_edit = "";
            currentObj.building_tower_edit = "";
            currentObj.landmark_edit = "";
            currentObj.add_lat = "";
            currentObj.add_lng = "";
            currentObj.add_id = "";

            currentObj.closechangeAddress();

            currentObj.$bvToast.toast(response.data.message, {
              variant: "success",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addclass (value) {
      // alert(value)

      //alert("Value is "+value)

      //let manual_google_address = "";

      // alert(manual_google_address)
      // alert(localStorage.getItem('del_address'))

      if (this.deliverytype === "delivery") {
        //alert(this.userinfolocal.address[0].google_address);
        if (
          this.userinfolocal.address != undefined &&
          this.userinfolocal.address.length > 0
        ) {
          /* this.userinfolocal.address.forEach((item, index = 0) => {
            //alert("item.google_address ", JSON.stringify(item));
            if (item.is_default == 1) {
              manual_google_address =
                this.userinfolocal.address[index].google_address;
              alert("index ", index);
              alert("1 manual_google_address ", manual_google_address);
            }
            index++;
          }); */
        } else {
          this.$bvToast.toast("Please add delivery address", {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          });

          return;
        }

        //  alert("manual_google_address ", manual_google_address);
        //  alert("del_address ", localStorage.getItem("del_address"));
        /* if (
          manual_google_address.localeCompare(
            localStorage.getItem("del_address")
          )
        ) {
          this.$bvToast.toast(
            "Looks like your current location and default location are different",
            {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            }
          );

          return;
        } */
      }

      if (
        this.digital_order_setting.order_later == 1 &&
        this.order_later == true
      ) {
        if (this.order_later == true && this.datetimeEmpty == "") {
          this.$bvToast.toast("Please enter valid date for Order Later", {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          });

          return;
        }

        if (this.order_later == true && this.ordertime == "") {
          this.$bvToast.toast("Please enter valid time for Order Later", {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          });

          return;
        }
      }

      if (value == 1) {
        this.classofaccord1 = "";
        this.classofaccord2 = "collapse";
        this.classofaccord3 = "collapse";
      }

      if (value == 2) {
        this.classofaccord1 = "collapse";
        this.classofaccord2 = "";
        this.classofaccord3 = "collapse";
      }

      if (value == 3) {
        this.classofaccord1 = "collapse";
        this.classofaccord2 = "collapse";
        this.classofaccord3 = "";
      }
    },
    changeLocLabel (value) {
      this.loc_label = value;
      this.loc_label_edit = value;
    },

    addNewAddress () {
      //alert("addNewAddress");
      if (this.comp_address == "") {
        this.$bvToast.toast("Please enter complete address", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.building_tower == "") {
        this.$bvToast.toast("Please enter building/tower", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.loc_label == "") {
        this.$bvToast.toast("Please select location label", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      let manual_address = {
        manual_address: this.comp_address,
        customer_phone: this.userinfolocal.phone,
        google_address: this.add_google_address,
        landmark: this.landmark,
        floor: this.building_tower,
        label: this.loc_label,
        latitude: localStorage.getItem("userlat"),
        longitude: localStorage.getItem("userlng"),
        is_default: 1,
      };

      let new_address = {
        store_id: this.userinfolocal.store_id,
        phone: this.userinfolocal.phone,
        action: "create",
        address: manual_address,
      };

      //   alert(JSON.stringify(new_address))

      //this.showModal = false
      //this.$refs['modal-center-manual-address'].hide()
      //this.closemanualAddress()

      /*
                     this.$bvToast.toast("Test Notification", {
                      variant: 'success',
                      toaster: 'b-toaster-bottom-left',
                      solid: true,
                     })*/

      let currentObj = this;

      currentObj.axios
        .post("address/", new_address)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);

          if (status == 200) {
            //   alert(JSON.stringify(response.data.customer))

            localStorage.setItem(
              "userinfo",
              JSON.stringify(response.data.customer)
            );

            currentObj.$cookie.set(
              "test",
              JSON.stringify(response.data.customer),
              1
            );

            currentObj.userinfolocal = JSON.parse(
              localStorage.getItem("userinfo")
            );

            currentObj.comp_address = "";
            currentObj.building_tower = "";
            currentObj.landmark = "";

            currentObj.closemanualAddress();

            currentObj.$bvToast.toast(response.data.message, {
              variant: "success",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteAdd (id) {
      let new_address = {
        data: {
          address_id: id,
          phone: this.userinfolocal.phone,
          store_id: this.userinfolocal.store_id,
        },
      };

      // alert(JSON.stringify(new_address))

      let currentObj = this;

      currentObj.axios
        .delete("address", new_address)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);

          if (status == 200) {
            //   alert(JSON.stringify(response.data.customer))

            localStorage.setItem(
              "userinfo",
              JSON.stringify(response.data.customer)
            );

            currentObj.$cookie.set(
              "test",
              JSON.stringify(response.data.customer),
              1
            );

            currentObj.userinfolocal = JSON.parse(
              localStorage.getItem("userinfo")
            );

            currentObj.comp_address = "";
            currentObj.building_tower = "";
            currentObj.landmark = "";

            currentObj.closemanualAddress();

            currentObj.$bvToast.toast(response.data.message, {
              variant: "success",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    filterChanged (value) {
      // alert('delivery type in local storage '+ localStorage.getItem('deliverytype'))
      this.$store.dispatch("saveOrderType", {
        ordertype: value,
      });

      localStorage.removeItem("table_room_no");
      this.table_room_no = "";
      localStorage.setItem("deliverytype", this.deliverytype);

      this.outletInformation.find((outlet) => {
        this.outlet_name = outlet.name;

        // console.log("Outlet name is " + this.outlet_name);

        //   alert(this.deliverytype)

        let pay =
          outlet.digital_ordering_settings.pay_gateway[this.deliverytype];
        //                    alert("Options are "+JSON.stringify(pay))

        this.pay_methods = [];
        pay.find((opt) => {
          if (opt.active == 1 && opt.flag != 6 && opt.flag != 6) {
            let pay_name = "";

            if (opt.flag == 0) {
              pay_name = "CASH";
            } else if (opt.flag == 1) {
              pay_name = "RAZORPAY";

              this.razorpay_key = opt.key;
            } else if (opt.flag == 2) {
              pay_name = "PayuMoney";
            } else if (opt.flag == 3) {
              pay_name = "COD";
            } else if (opt.flag == 4) {
              pay_name = "PayU";
            } else if (opt.flag == 5) {
              pay_name = "Pay Later";
            }

            this.pay_methods.push({
              text: pay_name,
              value: opt.flag,
            });
          }
        });
      });
    },
    filterChangedPay (value) {
      // alert(value)

      this.pay_option = value;
    },
    placeOrder () {
      // alert("Hello")

      //    alert("Order date "+this.datetimeEmpty)
      //  alert("Order time "+this.ordertime)

      let manual_address = "";
      let manual_add_floor = "";
      let manual_add_landmark = "";
      let manual_google_address = "";
      let manual_add_lat = "";
      let manual_add_lng = "";
      let label = "";

      if (this.deliverytype === "delivery") {
        if (this.userinfolocal.address.length > 0) {
          this.userinfolocal.address.forEach((item) => {
            if (item.is_default == 1) {
              manual_address = item.manual_address;
              manual_add_floor = item.floor;
              manual_add_landmark = item.landmark;
              manual_google_address = item.google_address;
              manual_add_lat = item.latitude;
              manual_add_lng = item.longitude;
              label = item.label;
            }
          });
        } else {
          this.$bvToast.toast("Please add delivery address", {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          });

          return;
        }
      }

      /* if (this.deliverytype === "delivery") {
        if (
          manual_google_address.localeCompare(
            localStorage.getItem("del_address")
          )
        ) {
          this.$bvToast.toast(
            "Looks like your current location and default location are different",
            {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            }
          );

          return;
        }
      } */

      let order_later_dateTime = "";
      let digi_order_type = this.getOrderLater ? 1 : this.order_type;
      /* alert(this.datetimeEmpty);
      alert(this.ordertime);
      alert(this.digi_order_type);
 */
      if (this.datetimeEmpty != "" && this.ordertime != "") {
        var today = new Date(localStorage.getItem("orderdate"));
        var day = today.getDate();
        var month = today.getMonth() + 1;
        var year = today.getFullYear();

        this.datetimeEmpty = year + "/" + month + "/" + day;

        // console.log("ordertime checkout ", localStorage.getItem("ordertime"));
        var todayTime = new Date(localStorage.getItem("ordertime"));

        // console.log("todayTime checkout ", todayTime);

        var h = todayTime.getHours();
        var mm = todayTime.getMinutes();
        //  var s = today.getSeconds();
        var now = h + ":" + mm + ":" + "00";

        let datetimeA = moment(this.datetimeEmpty + " " + now);

        // alert(datetimeA);
        var dateTimeEnd = moment(datetimeA, "YYYY-MM-DD");
        order_later_dateTime = dateTimeEnd.format("YYYY-MM-DD HH:mm:ss");
        // alert("Concated date " + dateTimeEnd.format("YYYY-MM-DD HH:mm:ss"));
      }

      if (this.order_type == 1 && this.datetimeEmpty == "") {
        this.$bvToast.toast("Please enter valid date for pre-order", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.order_type == 1 && this.ordertime == "") {
        this.$bvToast.toast("Please enter valid time  for pre-order", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      let reason = "";
      let storeId = this.userinfolocal.store_id;
      let custName = this.userinfolocal.name;
      let phone = this.userinfolocal.phone;
      let email = this.userinfolocal.email;
      let line1 = manual_google_address;
      let line2 =
        manual_address +
        ", " +
        manual_add_floor +
        ", " +
        manual_add_landmark +
        ", " +
        label;
      let orderLevelDiscount = this.applied_promo_disc_amt;
      let deliveryType = localStorage.getItem("deliverytype");
      let instructions = this.usernote;
      let quantity = 1;
      let app_source = "";

      // app_source = "grillfry_website";
      // app_source = 'food2all_website'
      // app_source = 'ariose_website'
      //  app_source = 'bowlsnboxes_website'
      // app_source = 'beintehaanbiryani_website'
      // app_source = "broasted_website";
      // app_source = "swadisht_website";
      // app_source = "mughliazz_website";
      // app_source ="puchkawala";
      app_source = "kurrykingdom";
      //for getting source from which order is receiving
      // app_source = "mahamangal_website";

      /* 
Sucess Redirect :https://beintehaanbiryani.com/order-online/#/order
Failure redirect : https://beintehaanbiryani.com/order-online/#/checkout */

      let surl = "";
      let furl = "";
      // surl = "https://grillfry.in/order-online/#/order";
      // furl = "https://grillfry.in/order-online/#/checkout";

      //  surl = "https://www.swadisht.co/order-online/#/order";
      //   furl = "https://www.swadisht.co/order-online/#/checkout";
      /* http://mughliaaz.com/order-online/#/order
http://mughliaaz.com/order-online/#/checkout */

      //if payu money is available add here success and failure links
      //  surl = "https://mahamangal.in/order-online/#/order";
      // furl = "https://mahamangal.in/order-online/#/checkout";

      let orderState = "placed";
      let orderSubtotal = this.cartTotalPrice;

      let order_level_charges = 0.0;

      let order_charges = [];

      // console.log("getAdditionalCharges "+JSON.stringify(this.getAdditionalCharges))

      this.getAdditionalCharges.forEach((item) => {
        order_level_charges = item.finaltotal;
        order_charges.push({
          title: item.charge_name,
          value: item.total,
          perOrFixed: item.per_or_fixed,
          store_id: storeId,
        });
      });

      let orderLevelTotalTaxes = this.cartGST.cgst + this.cartGST.sgst;
      let orderLevelTotalCharges = order_level_charges;

      let orderTotal;
      let total_item_charge = 0;
      let currentObj = this;
      currentObj.cartItems.find((items) => {
        if (items.add_charge.length > 0) {
          total_item_charge =
            total_item_charge + items.add_charge[0].calculated_charge_amt;
        }
      });

      if (this.cartGST.tax === "Incl.") {
        orderTotal =
          this.cartTotalPrice +
          order_level_charges -
          this.applied_promo_disc_amt;
      } else {
        orderTotal =
          this.cartTotalPrice +
          this.cartGST.cgst +
          this.cartGST.sgst +
          order_level_charges -
          this.applied_promo_disc_amt;
      }

      //alert(this.deliverytype)

      if (
        this.deliverytype === "dinein" &&
        this.digital_order_setting.order_limit_dinein != null &&
        orderTotal <= this.digital_order_setting.order_limit_dinein
      ) {
        this.$bvToast.toast(
          `Minimum order amount is Rs ${this.digital_order_setting.order_limit_dinein}`,
          {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          }
        );

        return;
      }

      if (
        this.deliverytype === "delivery" &&
        this.digital_order_setting.order_limit_delivery != null &&
        orderTotal <= this.digital_order_setting.order_limit_delivery
      ) {
        this.$bvToast.toast(
          `Minimum order amount is Rs ${this.digital_order_setting.order_limit_delivery}`,
          {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          }
        );

        return;
      }

      if (
        this.deliverytype === "pickup" &&
        this.digital_order_setting.order_limit_pickup != null &&
        orderTotal <= this.digital_order_setting.order_limit_pickup
      ) {
        this.$bvToast.toast(
          `Minimum order amount is Rs ${this.digital_order_setting.order_limit_pickup}`,
          {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          }
        );

        return;
      }

      /*  var currentTime = new Date();

var currentOffset = currentTime.getTimezoneOffset();

var ISTOffset = 330;   // IST offset UTC +5:30 

var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset)*60000);
*/

      var m = new Date();
      var dateString =
        m.getUTCFullYear() +
        "-" +
        (m.getUTCMonth() + 1) +
        "-" +
        m.getUTCDate() +
        " " +
        m.getHours() +
        ":" +
        m.getMinutes() +
        ":" +
        m.getSeconds();
      let orderDateTime = dateString;

      // alert("orderDateTime "+orderDateTime)

      let table_no = "";
      let room_no = "";
      if (localStorage.getItem("deliverytype") == "dinein") {
        table_no = localStorage.getItem("table_room_no");
        room_no = localStorage.getItem("table_room_no");
      }

      let currency = "";
      let store_logo;
      this.outletInformation.forEach((item) => {
        currency = item.currency_code;
        store_logo = item.logo;
      });

      //store_logo
      //  alert(store_logo)

      let paygateway_type = this.pay_option;

      let pay_name = "";

      if (paygateway_type == 0) {
        pay_name = "CASH";
      } else if (paygateway_type == 1) {
        pay_name = "RAZORPAY";
      } else if (paygateway_type == 2) {
        pay_name = "PayuMoney";
      } else if (paygateway_type == 3) {
        pay_name = "COD";
      } else if (paygateway_type == 4) {
        pay_name = "Payu";
      } else if (paygateway_type == 5) {
        pay_name = "Pay Later";
      }

      let order_later_datetime = order_later_dateTime;

      let coupon = this.coupon_code_name;
      let couponDisounttotal = this.applied_promo_disc_amt;
      let couponDisount = this.coupan_code_amt;
      let couponDisounttype = Number(this.coupon_code_type);
      let code_id = Number(this.code_id);
      let cust_lat = manual_add_lat ? manual_add_lat : 0.0;
      let cust_lng = manual_add_lng ? manual_add_lng : 0.0;

      let place_order = {};
      let order_items = [];
      let order_payments = [];

      order_payments.push({
        payment_option: pay_name,
        amount: orderTotal,
        store_id: storeId,
      });

      this.cartItems.find((items) => {
        //   console.log("Items in place order "+JSON.stringify(items))

        let title;
        let item_id;
        let price;
        let food_type;
        let quantity;
        let tax_method;
        let total;
        let tax_value;
        let total_with_tax;
        let tax_per;
        let is_devidable;
        let item_note;
        let product_group_id;
        let discounted_price;
        let discount_type;
        let discount_rate;
        let discount = 0;
        let order_child_options;
        let order_child_charges;
        let tax_name;

        if (items.item.items.addon_optgrp_price == 0) {
          //console.log("In if condition")
          let price_main = 0;

          if (items.item.items.discounted_price == 0) {
            price_main = items.item.items.sale_price;
          } else {
            price_main = items.item.items.discounted_price;
          }

          title = items.item.items.title;
          item_id = items.item.items.item_id;
          price = price_main;
          food_type = items.item.items.food_type;
          quantity = items.quantity;
          tax_method = items.item.items.tax_method;
          total = price * quantity;
          tax_value = items.item.items.tax_value;
          tax_name = items.item.items.tax_name;
          // total_with_tax = total + (tax_value * quantity)

          if (items.item.items.tax_method == 1) {
            total_with_tax = total * quantity;
          } else {
            total_with_tax = total + tax_value * quantity;
          }

          tax_per = items.item.items.tax_per;
          is_devidable = items.item.items.is_devidable;
          item_note = "";
          product_group_id = items.item.items.product_group;
          discounted_price = items.item.items.discounted_price;
          discount_type = items.item.items.discount_type;
          discount_rate = items.item.items.discount_rate;

          if (discount_rate > 0) {
            discount =
              (items.item.items.sale_price -
                items.item.items.discounted_price) *
              quantity;
          }

          order_child_options = [];
          order_child_charges = items.add_charge;
          // console.log("total_with_tax in if "+total_with_tax)
          // console.log("tax_value in if "+tax_value)
          // console.log("total in if "+total)
        } else {
          //                console.log("order childs")
          //console.log("In else condition")
          let price_main = 0;

          let tax_value_main = 0;

          if (items.item.items.discounted_price == 0) {
            // console.log("discounted_price 0")
            //  console.log("qty is "+items.item.items.addon_optgrp_price)
            price_main = items.item.items.addon_optgrp_price * items.quantity;

            tax_value_main = items.item.items.tax_value * items.quantity;
          } else {
            //console.log("discount available")
            price_main = items.item.items.addon_optgrp_price * items.quantity;
            tax_value_main = items.item.items.tax_value;
          }

          //  console.log("price_main "+price_main)

          title = items.item.items.add_opt_title;
          item_id = items.item.items.item_id;
          price = items.item.items.addon_optgrp_price;
          food_type = items.item.items.food_type;
          quantity = items.quantity;
          tax_method = items.item.items.tax_method;
          total = price_main;
          tax_value = items.item.items.tax_value;
          tax_name = items.item.items.tax_name;
          //

          if (items.item.items.tax_method == 1) {
            total_with_tax = total;
          } else {
            total_with_tax = total + tax_value_main;
          }

          tax_per = items.item.items.tax_per;
          is_devidable = items.item.items.is_devidable;
          item_note = "";
          product_group_id = items.item.items.product_group;
          discounted_price = items.item.items.discounted_price;
          discount_type = items.item.items.discount_type;
          discount_rate = items.item.items.discount_rate;

          if (discount_rate > 0) {
            discount =
              (items.item.items.sale_price -
                items.item.items.discounted_price) *
              quantity;
          }

          order_child_options = items.item.items.order_child_options;
          order_child_charges = items.add_charge;

          // console.log("total_with_tax in else "+total_with_tax)
          //  console.log("tax_value_main in else "+tax_value_main)
          //  console.log("total in else "+total)
        }

        order_items.push({
          title: title,
          item_id: item_id,
          price: price,
          food_type: food_type,
          quantity: quantity,
          tax_method: tax_method,
          total: total,
          tax_name: tax_name,
          total_with_tax: total_with_tax,
          tax_per: tax_per,
          tax_value: tax_value,
          is_devidable: is_devidable,
          item_note: item_note,
          product_group_id: product_group_id,
          discounted_price: discounted_price,
          discount_type: discount_type,
          discount_rate: discount_rate,
          discount: discount,
          order_child_options: order_child_options,
          order_child_charges: order_child_charges,
        });
      });

      let extra_details = {};

      /*tax_inex_method = 0 is excluding
tax_inex_method = 1 is including */

      let tax_inex_method;
      let tax_name;
      let amount;
      let tax_per;

      tax_inex_method = this.cartGST.tax_inex_method;
      tax_name = this.cartGST.tax_name;
      tax_per = this.cartGST.gstper;
      amount = parseFloat(this.cartGST.cgst) + parseFloat(this.cartGST.sgst);

      if (tax_inex_method === 0) {
        extra_details = {
          exlusive_tax: amount,
          tax: [
            {
              name: tax_name + " " + (tax_per + "%"),
              tax_percent: tax_per,
              amount: amount,
              tax_inclusive: false,
            },
          ],
          order_later_time_slots:
            digi_order_type == 1
              ? localStorage.getItem("selected_order_time_slots")
              : "",
        };
      } else {
        extra_details = {
          inclusive_tax: amount,
          tax: [
            {
              name: tax_name + " " + (tax_per + "%"),
              tax_percent: tax_per,
              amount: amount,
              tax_inclusive: true,
            },
          ],
          order_later_time_slots:
            digi_order_type == 1
              ? localStorage.getItem("selected_order_time_slots")
              : "",
        };
      }

      place_order = {
        reason: reason,
        storeId: storeId,
        custName: custName,
        phone: phone,
        email: email,
        line1: line1,
        line2: line2,
        orderLevelDiscount: orderLevelDiscount,
        deliveryType: deliveryType,
        instructions: instructions,
        quantity: quantity,
        orderLevelTotalCharges: orderLevelTotalCharges,
        orderLevelTotalTaxes: orderLevelTotalTaxes,
        orderState: orderState,
        orderSubtotal: orderSubtotal,
        orderTotal: orderTotal,
        orderDateTime: orderDateTime,
        table_no: table_no,
        room_no: room_no,
        currency: currency,
        paygateway_type: paygateway_type,
        digi_order_type: digi_order_type,
        order_later_datetime: order_later_datetime,
        coupon: coupon,
        couponDisounttotal: couponDisounttotal,
        couponDisount: couponDisount,
        couponDisounttype: couponDisounttype,
        code_id: code_id,
        cust_lat: cust_lat,
        cust_lng: cust_lng,
        app_source: app_source,
        order_items,
        order_payments,
        order_charges,
        extra_details,
      };
      //surl;
      //furl;
      //store_logo;
      //console.log("Place order data is " + JSON.stringify(place_order));

      this.axios
        .post("order", place_order)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);
          // let order_id = JSON.stringify(response.data.digi_orderid);

          if (status == 200) {
            if (
              paygateway_type === 0 ||
              paygateway_type === 3 ||
              paygateway_type === 5
            ) {
              currentObj.$bvToast.toast(`Order Placed successfully`, {
                title: "Order message",
                variant: "success",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });

              currentObj.$store.dispatch("clearCartItems");
              localStorage.removeItem("coupon_code_name");
              localStorage.removeItem("coupon_code_type");
              localStorage.removeItem("coupan_code_id");
              localStorage.removeItem("coupan_discount");
              localStorage.removeItem("order_later");
              localStorage.removeItem("order_now");
              localStorage.removeItem("ordertime");
              localStorage.removeItem("orderdate");
              localStorage.removeItem("deliverytype");

              currentObj.$store.dispatch("saveOrderLater", {
                order_later: false,
              });
              currentObj.$store.dispatch("saveOrderNow", {
                order_now: true,
              });

              currentObj.$router.push({
                name: "order",
                // params: { order_id: order_id }
              });
            }

            // alert("Order id is "+order_id)

            //navigating

            if (paygateway_type == 2) {
              var RequestData = {
                key: response.data.pay_gateway.merchant_key,
                txnid: response.data.pay_gateway.transaction_id,
                hash: response.data.pay_gateway.hash,
                amount: response.data.pay_gateway.amount,
                firstname: custName,
                phone: phone,
                email: "demo@gmail.com",
                productinfo: "Bill Payment",
                surl: surl,
                furl: furl,
              };

              //  console.log(JSON.stringify(RequestData))
              var Handler = {
                responseHandler: function (BOLT) {
                  // console.log("Response is "+JSON.stringify(BOLT))

                  /// {"response":{"txnStatus":"CANCEL","txnMessage":"Overlay closed by consumer"}}
                  console.log("Cancel Response is " + BOLT.response.txnStatus);

                  if (BOLT.response.txnStatus == "CANCEL") {
                    currentObj.$bvToast.toast(
                      `Payment is still pending. Please try again`,
                      {
                        variant: "danger",
                        toaster: "b-toaster-bottom-left",
                        solid: true,
                      }
                    );
                  }

                  if (BOLT.response.txnStatus == "SUCCESS") {
                    currentObj.$bvToast.toast(`Transaction Successful`, {
                      variant: "success",
                      toaster: "b-toaster-bottom-left",
                      solid: true,
                    });

                    //  currentObj.$swal('Transaction Successful. Order Successfully placed');

                    currentObj.$store.dispatch("clearCartItems");
                    localStorage.removeItem("coupon_code_name");
                    localStorage.removeItem("coupon_code_type");
                    localStorage.removeItem("coupan_code_id");
                    localStorage.removeItem("coupan_discount");
                    localStorage.removeItem("order_later");
                    localStorage.removeItem("order_now");
                    localStorage.removeItem("ordertime");
                    localStorage.removeItem("orderdate");
                    localStorage.removeItem("deliverytype");
                    currentObj.$store.dispatch("saveOrderLater", {
                      order_later: false,
                    });
                    currentObj.$store.dispatch("saveOrderNow", {
                      order_now: true,
                    });

                    let order_stat_update = {
                      amount: BOLT.response.amount,
                      udf5: BOLT.response.udf5,
                      udf3: BOLT.response.udf3,
                      split_info: BOLT.response.amount_split,
                      udf4: BOLT.response.udf4,
                      udf1: BOLT.response.udf1,
                      udf2: BOLT.response.udf2,
                      customerName: BOLT.response.firstname,
                      productInfo: BOLT.response.productInfo,
                      customerPhone: BOLT.response.phone,
                      additionalCharges: "",
                      paymentId: BOLT.response.paymentId,
                      customerEmail: BOLT.response.email,
                      // merchantTransactionId: this.state.paymentData.transaction_id,
                      merchantTransactionId: BOLT.response.txnid
                        ? BOLT.response.txnid
                        : "",
                      error_Message: BOLT.response.error_Message,
                      notificationId: BOLT.response.notificationId
                        ? BOLT.response.notificationId
                        : "",
                      hash: BOLT.response.hash,
                      status: BOLT.response.txnMessage,
                    };

                    //  console.log("order_stat_update is "+JSON.stringify(order_stat_update))

                    currentObj.axios
                      .post("payumoney_success_webhook", order_stat_update)
                      .then(function (res) {
                        console.log(
                          "Order status response is " + JSON.stringify(res)
                        );

                        currentObj.$router.push({
                          name: "order",
                          // params: { order_id: order_id }
                        });
                      })
                      .catch((error) => {
                        //this.errorMessage = error.message;

                        console.log("Error in order status updating " + error);
                        //alert("There was an error! "+ error);
                      });
                  }

                  if (BOLT.response.txnStatus == "FAIL") {
                    currentObj.$bvToast.toast(`Transaction Failed`, {
                      variant: "danger",
                      toaster: "b-toaster-bottom-left",
                      solid: true,
                    });

                    //  currentObj.$swal('Transaction Successful. Order Successfully placed');

                    let order_stat_update = {
                      amount: BOLT.response.amount,
                      udf5: BOLT.response.udf5,
                      udf3: BOLT.response.udf3,
                      split_info: BOLT.response.amount_split,
                      udf4: BOLT.response.udf4,
                      udf1: BOLT.response.udf1,
                      udf2: BOLT.response.udf2,
                      customerName: BOLT.response.firstname,
                      productInfo: BOLT.response.productInfo,
                      customerPhone: BOLT.response.phone,
                      additionalCharges: "",
                      paymentId: BOLT.response.paymentId,
                      customerEmail: BOLT.response.email,
                      // merchantTransactionId: this.state.paymentData.transaction_id,
                      merchantTransactionId: BOLT.response.txnid
                        ? BOLT.response.txnid
                        : "",
                      error_Message: BOLT.response.error_Message,
                      notificationId: BOLT.response.notificationId
                        ? BOLT.response.notificationId
                        : "",
                      hash: BOLT.response.hash,
                      status: BOLT.response.txnMessage,
                    };

                    // console.log("order_stat_update is "+JSON.stringify(order_stat_update))

                    currentObj.axios
                      .post("payumoney_fail_webhook", order_stat_update)
                      .then(function (res) {
                        console.log(
                          "Order status response is " + JSON.stringify(res)
                        );
                      })
                      .catch((error) => {
                        //this.errorMessage = error.message;

                        console.log("Error in order status updating " + error);
                        //alert("There was an error! "+ error);
                      });
                  }
                },
                catchException: function (BOLT) {
                  console.log("Exception is " + JSON.stringify(BOLT));
                },
              };
              window.bolt.launch(RequestData, Handler);
            }

            if (paygateway_type == 1) {
              // console.log("in razorpay gateway")
              var options = {
                key: currentObj.razorpay_key, // Enter the Key ID generated from the Dashboard
                amount: response.data.pay_gateway.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
                currency: currency,
                name: currentObj.outlet_name,
                description: response.data.pay_gateway.entity,
                image: store_logo,
                //"image": "http://18.224.231.34/assets/img/logo.png",
                //"image": "https://grillfry.in/assets/img/logo.jpg",
                //"image": "https://techmainstay.com/images/logo.png",
                order_id: response.data.pay_gateway.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                handler: function (response) {
                  response;
                  // alert("Hello")
                  // console.log(response)
                  currentObj.$bvToast.toast(`Transaction Successful`, {
                    variant: "success",
                    toaster: "b-toaster-bottom-left",
                    solid: true,
                  });

                  currentObj.$store.dispatch("clearCartItems");

                  localStorage.removeItem("coupon_code_name");
                  localStorage.removeItem("coupon_code_type");
                  localStorage.removeItem("coupan_code_id");
                  localStorage.removeItem("coupan_discount");
                  localStorage.removeItem("order_later");
                  localStorage.removeItem("order_now");
                  localStorage.removeItem("ordertime");
                  localStorage.removeItem("orderdate");
                  localStorage.removeItem("deliverytype");
                  currentObj.$store.dispatch("saveOrderLater", {
                    order_later: false,
                  });
                  currentObj.$store.dispatch("saveOrderNow", {
                    order_now: true,
                  });
                  currentObj.$router.push({
                    name: "order",
                    // params: { order_id: order_id }
                  });

                  //   alert(response.razorpay_payment_id);
                  // alert(response.razorpay_order_id);
                  // alert(response.razorpay_signature)
                },
                prefill: {
                  name: custName,
                  email: email,
                  contact: phone,
                },
                notes: {
                  address: line1,
                },
                theme: {
                  color: "#3399cc",
                },
              };

              var rzp1 = new window.Razorpay(options);
              rzp1.on("payment.failed", function (response) {
                currentObj.$bvToast.toast(`Transaction Failed`, {
                  variant: "danger",
                  toaster: "b-toaster-bottom-left",
                  solid: true,
                });

                console.log("In razorpay failed " + JSON.stringify(response));
                // alert(response.error.code);
                //alert(response.error.description);
                //alert(response.error.source);
                //alert(response.error.step);
                //alert(response.error.reason);
                //alert(response.error.metadata.order_id);
                //alert(response.error.metadata.payment_id);
              });

              rzp1.open();
            }

            if (paygateway_type == 4) {
              currentObj.payu_key = response.data.pay_gateway.merchant_key;
              currentObj.payu_txnid = response.data.pay_gateway.transaction_id;
              currentObj.payu_productinfo = "Bill Payment";
              currentObj.payu_amount = response.data.pay_gateway.amount;
              currentObj.payu_email = "demo@gmail.com";
              currentObj.payu_firstname = custName;
              currentObj.payu_lastname = "";
              currentObj.payu_surl = surl;
              currentObj.payu_furl = furl;
              currentObj.payu_phone = phone;
              currentObj.payu_hash = response.data.pay_gateway.hash;

              setTimeout(function () {
                document.getElementById("myForm").submit();

                // currentObj.$store.dispatch('clearCartItems')
              }, 20);
            }
          }
          //  console.log(JSON.stringify(response))
        })
        .catch((error) => {
          //this.errorMessage = error.message;
          //  alert("There was an error! "+ error);
          console.log("Error in order placing " + error);
          currentObj.$bvToast.toast(`Order Not placed. Please try again.`, {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          });
        });
    },
    validateTime () {
      //alert("selected time is "+this.ordertime)

      if (this.ordertime != "") {
        var today = new Date(this.ordertime);
        var h = today.getHours();
        var m = today.getMinutes();
        //  var s = today.getSeconds();
        var now = h + ":" + m + ":" + "00";

        //  alert("Now is "+now)

        var format = "hh:mm:ss";
        var time = moment(now, format);
        var beforeTime = moment(
          this.digital_order_setting.day_start_time,
          format
        );
        var afterTime = moment(
          this.digital_order_setting.day_close_time,
          format
        );

        if (time.isBetween(beforeTime, afterTime)) {
          //alert('is between '+now)
          this.ordertime = now;
        } else {
          //alert('is not between')

          this.ordertime = "";
          this.$bvToast.toast("Please Select Another time.", {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          });
        }
      }
    },
    validateDate () {
      // alert("Date is "+this.datetimeEmpty)

      if (this.datetimeEmpty != "") {
        var today = new Date(this.datetimeEmpty);
        var day = today.getDate();
        var month = today.getMonth() + 1;
        var year = today.getFullYear();

        this.datetimeEmpty = year + "/" + month + "/" + day;
      }

      //alert("order_date "+order_date)
    },
    changeDigiOrderType () {
      if (this.digi_order_type) {
        this.order_type = 1;
      } else {
        this.order_type = 0;
      }

      //alert("digi order type is "+this.order_type)
    },
    changeOrderType () {
      // alert('checkout changeOrderType')
      // this.changeOrderType()
      this.order_type_modal = true;
    },
    removeCheckoutItemChange () {
      //  alert("Changed")

      this.currentCartItemCount = this.cartItemCount;

      this.removePromoCode();

      localStorage.removeItem("coupan_discount");
      this.applied_promo_disc_amt = 0;
      localStorage.setItem("coupan_discount", this.applied_promo_disc_amt);

      this.$bvToast.toast("Applied discount removed", {
        variant: "danger",
        toaster: "b-toaster-bottom-right",
        solid: true,
      });

      /*
        this.boxTwo = ''
        this.$bvModal.msgBoxConfirm('Please confirm that you want to change cart items. If you change the cart items then discount will be removed', {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          centered: true
        })
          .then(value => {
            this.boxTwo = value

           // alert("value is "+value)

            if(value) {
                
            }
            else {
// An error occurred
                this.currentCartItemCount = this.cartItemCount
            }
          })
          .catch(err => {
            // An error occurred
            err
          })*/
    },
  },
  created () {
    //  alert(JSON.stringify(localStorage.getItem('userinfo')))

    var days = parseInt(this.digital_order_setting.order_later_days_limit) - 1; // Days you want to subtract
    //("Days are "+)
    var date = new Date();
    var last = new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
    var day = last.getDate();
    var month = last.getMonth() + 1;
    var year = last.getFullYear();

    var dateString = year + "-" + month + "-" + day;

    var dateTime = moment(this.digital_order_setting.todays_date, "YYYY-MM-DD");
    var dateTimeEnd = moment(dateString, "YYYY-MM-DD");

    //console.log("Concated date "+dateTimeEnd.format('YYYY-MM-DD'))

    this.minDatetime = dateTime.format("YYYY-MM-DD");
    this.maxDatetime = dateTimeEnd.format("YYYY-MM-DD");

    // alert(this.minDatetime);
    //  alert(this.maxDatetime);
    if (this.cartItems.length == 0) {
      this.$router.push("/").catch(() => { });
    }
    this.outletInformation.find((outlet) => {
      this.outlet_name = outlet.name;

      //  console.log("Outlet name is "+this.outlet_name)

      //   alert(this.deliverytype)

      let pay = outlet.digital_ordering_settings.pay_gateway[this.deliverytype];
      //                    alert("Options are "+JSON.stringify(pay))

      this.pay_methods = [];
      pay.find((opt) => {
        if (opt.active == 1 && opt.flag != 6) {
          let pay_name = "";

          if (opt.flag == 0) {
            pay_name = "CASH";
          } else if (opt.flag == 1) {
            pay_name = "RAZORPAY";

            this.razorpay_key = opt.key;
          } else if (opt.flag == 2) {
            pay_name = "PayuMoney";
          } else if (opt.flag == 3) {
            pay_name = "COD";
          } else if (opt.flag == 4) {
            pay_name = "Payu";
          } else if (opt.flag == 5) {
            pay_name = "Pay Later";
          }

          this.pay_methods.push({
            text: pay_name,
            value: opt.flag,
          });
        }
      });
    });

    this.$nextTick(function () {
      // $("#divTest").scrollTop($("#divTest")[0].scrollHeight);

      $(window).scrollTop(0);
    });

    // alert("getOrderLater ", this.getOrderLater);
    //this.getAdditionalCharges()
  },
  mounted () {
    /*
{"id":76064,"store_id":"53456436918127","phone":"8830427223","name":"VDS","address_line1":"Sangli","dob":null,"anniversary":null,"cust_type":1}
*/
    //  console.log("Outlet information is "+JSON.stringify(this.outletInformation))
    // this.userinfolocal = localStorage.getItem('userinfo')
    //   alert(JSON.stringify(localStorage.getItem('userinfo')))
    this.user_name = this.userinfolocal.name;
    this.user_mobile = this.userinfolocal.phone;

    // this.user_email = this.userinfolocal.
    this.user_address = this.userinfolocal.address_line1;

    // this.user_pin_code = this.userinfolocal.
    this.user_select_outlet = this.setOutletName;

    if (this.deliverytype == "delivery") {
      this.user_select_del_address = localStorage.getItem("del_address");
    } else {
      this.outletInformation.find((outlet) => {
        this.user_select_del_address = outlet.address;
      });
    }

    // alert(localStorage.getItem("orderdate"));

    this.datetimeEmpty = localStorage.getItem("orderdate");
    this.ordertime = localStorage.getItem("ordertime");

    //  var today = new Date(this.datetimeEmpty);

    //alert(typeof this.ordertime);

    // month is 0-based, that's why we need dataParts[1] - 1
    //var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

    //alert(+dateParts[1] - 1 + "/" + dateParts[2] + "/" + dateParts[0] - 1);

    /* if (
      localStorage.getItem("order_later") == true ||
      localStorage.getItem("order_later") == "true"
    ) {
      this.digi_order_type = true;
      this.changeDigiOrderType();
    } */
    // this.digi_order_type = localStorage.getItem("order_later") == true ? 1 : 0;

    //alert("order_later " + localStorage.getItem("order_later"));
    // alert(this.userinfolocal.address.length)
  },
  updated () {
    //alert("distance is "+ localStorage.getItem("deliverylocation"))
    //alert("getOrderLater ", localStorage.getItem("order_later"));
    if (
      this.applied_promo_disc_amt > 0 &&
      this.currentCartItemCount != this.cartItemCount &&
      this.currentCartItemCount > 0
    ) {
      //alert("if ")
      this.removeCheckoutItemChange();
    } else {
      this.currentCartItemCount = this.cartItemCount;

      // alert("else ")
    }

    // alert("Updated");
    this.$store.dispatch("saveOrderDate", {
      order_date: this.datetimeEmpty,
    });
    this.$store.dispatch("saveOrderTime", {
      order_time: this.ordertime,
    });

    if (this.cartItems.length == 0) {
      this.$router.push("/").catch(() => { });
    }

    if (this.digital_order_setting.order_later_time_slots) {
      this.order_later_time_slots =
        this.digital_order_setting.order_later_time_slots;
    }
  },
};
</script>



<style>
.custom-select {
  display: inline-block;
  width: 100%;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
}

input[type="checkbox"] {
  margin: 0px -20px 0;
  height: 20px;
  margin-top: 1px \9;
  line-height: normal;
  width: 16px;
  position: absolute;
  display: none;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

.order-items-container {
  padding: 15px 15px 5px;
  background: #fff;
  border-top-left-radius: 34px;
}

.order-items-container-child {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  /*margin-bottom: 15px;*/
  position: relative;
}

.order-item-details-wrapper {
  display: -webkit-flex;
  display: flex;
}

.ordercart-view-container {
  color: #000;
  font-weight: 700;
}

.order-item-image {
  height: 70px;
  width: 70px;
  min-height: 70px;
  min-width: 70px;
  border-radius: 40px;
  background-size: cover;
  background-color: hsla(0, 3.6%, 78%, 0.43137254901960786);
}

.order-item-title-container {
  overflow: hidden;
  padding: 6px;
}

.order-item-price {
  font-size: 12px;
  color: #9ea6b9;
  letter-spacing: 1px;
  padding-left: 7px;
}

.d-flex {
  display: -webkit-flex !important;
  display: flex !important;
}

div.ordercart-view-container div.order-items-container div.order-items-container-child div.product-item-sub-container {
  left: auto;
}

.product-item-sub-container {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
  position: absolute;
  bottom: 13px;
  right: 10px;
  /*left: 10px;*/
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.update-item-wrapper {
  display: -webkit-flex;
  display: flex;
  width: 75px;
  height: 30px;
}

.decrement {
  width: 22px;
  border: 1px solid #202431;
  /*border-radius: 18px 0 0 18px;*/
  font-size: 1.3em;
}

.update-item-button {
  margin: 0;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700 !important;
}

.qty-container {
  border-radius: 0;
  -webkit-flex: 1 1;
  flex: 1 1;
  word-wrap: normal;
}

.update-item-button {
  margin: 0;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700 !important;
}

.button-secondary-cta {
  background: #374b43;
  color: #fff;
}

.increment {
  width: 22px;
  border: 1px solid #202431;
  /*border-radius: 0 18px 18px 0;*/
  font-size: 1.3em;
}

.add_address_button {
  display: -webkit-flex;
  display: flex;
  margin-top: 5px;
  -webkit-align-items: baseline;
  align-items: baseline;
  font-size: 14px;
  width: 100%;
  border-radius: 4px;
  padding: 10px 10px 10px 10px;
  border: 1.3px solid #bdbdbd;
}

.add-address-container .add_address_button {
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  background: #fff;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.savedaddress-modal-wrapper {
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
}

.savedaddress-modal-wrapper .savedaddress-modal .add-address-container .address {
  font-weight: 700;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
}

.address .content {
  /*width: 80%;*/
  font-size: 16px !important;
}

.savedaddress-modal-wrapper .savedaddress-modal .add-address-container .address {
  font-weight: 700;
}

.address button {
  border: none;
  padding: 5px;
  background-color: #28322e;
  color: #fff;
  border-radius: 5px;
  height: 30px;
  width: 40px;
}

.jss28 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 2px;
}

.jss28>* {
  margin: 4px;
}

.MuiChip-outlined {
  border: 1px solid rgba(0, 0, 0, 0.23);
  background-color: transparent;
}

.MuiChip-clickable {
  cursor: pointer;
  -moz-user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.MuiChip-root {
  color: rgba(0, 0, 0, 0.87);
  border: none;
  cursor: default;
  height: 32px;
  display: inline-flex;
  outline: 0;
  padding: 0;
  font-size: 0.8125rem;
  box-sizing: border-box;
  transition: background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  white-space: nowrap;
  border-radius: 16px;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;
  background-color: #e0e0e0;
}

.MuiButtonBase-root {
  color: inherit;
  border: 0;
  cursor: pointer;
  margin: 0;
  display: inline-flex;
  outline: 0;
  padding: 0;
  position: relative;
  align-items: center;
  border-radius: 0;
  vertical-align: middle;
  -moz-appearance: none;
  justify-content: center;
  text-decoration: none;
  -moz-user-select: none;
  background-color: transparent;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
}

.MuiChip-label {
  overflow: hidden;
  white-space: nowrap;
  padding-left: 12px;
  padding-right: 12px;
  text-overflow: ellipsis;
}

.MuiTouchRipple-root {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  overflow: hidden;
  position: absolute;
  border-radius: inherit;
  pointer-events: none;
}

.MuiChip-outlined {
  border: 1px solid rgba(0, 0, 0, 0.23);
  background-color: transparent;
}

.savedaddress-modal-wrapper .savedaddress-modal .add-address-container form .chips-group .active {
  border: 2px solid #3cb371;
}

.cart-customer-address {
  font-size: 0.8rem;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  padding: 10px;
}

.order_instruction {
  display: -webkit-flex;
  display: flex;
  margin-top: 5px;
  -webkit-align-items: baseline;
  align-items: baseline;
  font-size: 1.2rem;
  width: 100%;
  border-radius: 4px;
  padding: 5px 5px 5px 15px;
  border: 1.3px solid #bdbdbd;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.addresscontainer {
  display: -webkit-flex;
  display: flex;
  width: 100%;
}

.full-address {
  /*width: 80%;*/
  padding: 0 10px;
  opacity: 0.7;
}

.addresscontainer button {
  border: none;
  background: #28322e !important;
  font-size: small;
  height: 35px;
}

.address-list {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
  overflow-x: auto;
  max-height: 50vh;
  overflow-x: scroll;
}

.list-group {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.saved-address {
  width: 100%;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin-bottom: 5px;
}

.d-flex {
  display: -webkit-flex !important;
  display: flex !important;
}

.address-label {
  font-weight: 700;
}

.badge1 {
  font-size: small;
  margin-left: 5px;
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}

.badge1 {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.add-address-button {
  border: none;
  background: #fff;
}

.order_later {
  background-color: #ffbb0e;
  color: #fff;
  width: 100%;
}

.order_now {
  background-color: #ffbb0e;
  color: #fff;
  width: 100%;
}

.order_now_active {
  background-color: #f5c464;
  color: #fff;
  width: 100%;
}

.order_later_active {
  background-color: #f5c464;
  color: #fff;
  width: 100%;
}

.vdatetime-input {
  width: 100%;
}
</style>